//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class ApiClientBase {
    constructor(config) {
        this.transformOptions = (options) => {
            this.config.applyTransformToRequest(options);
            return Promise.resolve(options);
        };
        this.config = config;
    }
}
export class AccountApiClient extends ApiClientBase {
    constructor(configuration, baseUrl, http) {
        super(configuration);
        this.jsonParseReviver = undefined;
        this.http = http ? http : window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Address search with suggestion
     * @param address (optional) Partial address to search for
     */
    addressSearchSuggestion(address) {
        let url_ = this.baseUrl + "/address/search/suggestion?";
        if (address !== undefined && address !== null)
            url_ += "address=" + encodeURIComponent("" + address) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddressSearchSuggestion(_response);
        });
    }
    processAddressSearchSuggestion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AddressSuggestionDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Customer Holiday Address - Add
     * @param body (optional) Request body
     */
    customerHolidayAddressPost(body) {
        let url_ = this.baseUrl + "/customerHolidayAddress";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomerHolidayAddressPost(_response);
        });
    }
    processCustomerHolidayAddressPost(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Customer Holiday Address - delete
     */
    customerHolidayAddressDelete() {
        let url_ = this.baseUrl + "/customerHolidayAddress";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomerHolidayAddressDelete(_response);
        });
    }
    processCustomerHolidayAddressDelete(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Customer Holiday Address - get
     * @return OK
     */
    customerHolidayAddressGet() {
        let url_ = this.baseUrl + "/customerHolidayAddress";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomerHolidayAddressGet(_response);
        });
    }
    processCustomerHolidayAddressGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCustomerAddressHolidayInformationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to retrieve customer holiday address info", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Customer Holiday Preview - post
     * @param body (optional) Request body
     * @return OK
     */
    previewCustomerHoliday(body) {
        let url_ = this.baseUrl + "/previewCustomerHoliday";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processPreviewCustomerHoliday(_response);
        });
    }
    processPreviewCustomerHoliday(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCustomerAddressHolidayPreviewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to retrieve the preview for customer holiday", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional) Request body
     * @return OK
     */
    addressValidate(body) {
        let url_ = this.baseUrl + "/address/validate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddressValidate(_response);
        });
    }
    processAddressValidate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidateAddressResponseDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Delivery Address - Validate
     * @param body (optional) Request body
     * @return OK
     */
    addressDeliveryValidate(body) {
        let url_ = this.baseUrl + "/address/delivery/validate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddressDeliveryValidate(_response);
        });
    }
    processAddressDeliveryValidate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidateDeliveryAddressDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional) Request body
     * @return OK
     */
    addressChanged(body) {
        let url_ = this.baseUrl + "/address/changed";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processAddressChanged(_response);
        });
    }
    processAddressChanged(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Beta Preference Data
     */
    betaPreferences() {
        let url_ = this.baseUrl + "/beta/preferences";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBetaPreferences(_response);
        });
    }
    processBetaPreferences(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Beta Recipe Data
     */
    betaRecipes() {
        let url_ = this.baseUrl + "/beta/recipes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBetaRecipes(_response);
        });
    }
    processBetaRecipes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Beta Extras Data
     */
    betaExtras() {
        let url_ = this.baseUrl + "/beta/extras";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processBetaExtras(_response);
        });
    }
    processBetaExtras(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    campaignEnrolled() {
        let url_ = this.baseUrl + "/campaign/enrolled";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCampaignEnrolled(_response);
        });
    }
    processCampaignEnrolled(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(EnrolledCampaignDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    campaignEligible() {
        let url_ = this.baseUrl + "/campaign/eligible";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCampaignEligible(_response);
        });
    }
    processCampaignEligible(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(EligibleCampaignDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    campaignGet(code) {
        let url_ = this.baseUrl + "/campaign/get/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCampaignGet(_response);
        });
    }
    processCampaignGet(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CampaignGroupDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    campaignJoin(body) {
        let url_ = this.baseUrl + "/campaign/join";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCampaignJoin(_response);
        });
    }
    processCampaignJoin(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CampaignJoinResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * CustomerTrigger
     */
    customerTriggers() {
        let url_ = this.baseUrl + "/customer/triggers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomerTriggers(_response);
        });
    }
    processCustomerTriggers(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerTriggerResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Customer Messages
     * @param subscriptionNumber (optional)
     * @param deliveryDateId (optional)
     */
    customersMessages(triggerCode, subscriptionNumber, deliveryDateId) {
        let url_ = this.baseUrl + "/customers/messages/{triggerCode}?";
        if (triggerCode === undefined || triggerCode === null)
            throw new Error("The parameter 'triggerCode' must be defined.");
        url_ = url_.replace("{triggerCode}", encodeURIComponent("" + triggerCode));
        if (subscriptionNumber !== undefined && subscriptionNumber !== null)
            url_ += "subscriptionNumber=" + encodeURIComponent("" + subscriptionNumber) + "&";
        if (deliveryDateId !== undefined && deliveryDateId !== null)
            url_ += "deliveryDateId=" + encodeURIComponent("" + deliveryDateId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomersMessages(_response);
        });
    }
    processCustomersMessages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = GetCustomerMessageResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Customer Messages by trigger codes and delivery ids
     * @param body (optional) GetCustomerMessageBulkAsync request body
     */
    customerMessagesBulk(body) {
        let url_ = this.baseUrl + "/customer/messages/bulk";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomerMessagesBulk(_response);
        });
    }
    processCustomerMessagesBulk(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetCustomerMessageBulkResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Customer Messages by Trigger Codes
     * @param subscriptionNumber (optional)
     * @param deliveryDateId (optional)
     * @param triggerCodes (optional)
     */
    customersCmpMessages(subscriptionNumber, deliveryDateId, triggerCodes) {
        let url_ = this.baseUrl + "/customers/cmp/messages?";
        if (subscriptionNumber !== undefined && subscriptionNumber !== null)
            url_ += "subscriptionNumber=" + encodeURIComponent("" + subscriptionNumber) + "&";
        if (deliveryDateId !== undefined && deliveryDateId !== null)
            url_ += "deliveryDateId=" + encodeURIComponent("" + deliveryDateId) + "&";
        if (triggerCodes !== undefined && triggerCodes !== null)
            triggerCodes && triggerCodes.forEach(item => { url_ += "triggerCodes=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomersCmpMessages(_response);
        });
    }
    processCustomersCmpMessages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(GetCustomerMessageDto.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Customer Profile
     */
    customersMe() {
        let url_ = this.baseUrl + "/customers/me";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomersMe(_response);
        });
    }
    processCustomersMe(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CustomerProfileResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Customers - Update recipe card preference
     * @param body (optional) Request body
     */
    customersUpdateRecipeCardPreference(body) {
        let url_ = this.baseUrl + "/customers/updateRecipeCardPreference";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCustomersUpdateRecipeCardPreference(_response);
        });
    }
    processCustomersUpdateRecipeCardPreference(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Account - Health
     */
    healthAvailability() {
        let url_ = this.baseUrl + "/_health/availability";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processHealthAvailability(_response);
        });
    }
    processHealthAvailability(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Account - Health Warmup
     */
    healthWarmup() {
        let url_ = this.baseUrl + "/_health/warmup";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processHealthWarmup(_response);
        });
    }
    processHealthWarmup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Account - Health, FrontDoor
     */
    healthFrontdoor() {
        let url_ = this.baseUrl + "/_health/frontdoor";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processHealthFrontdoor(_response);
        });
    }
    processHealthFrontdoor(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Account - Health, Version
     */
    healthVersion() {
        let url_ = this.baseUrl + "/_health/version";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processHealthVersion(_response);
        });
    }
    processHealthVersion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Orders
     */
    orders() {
        let url_ = this.baseUrl + "/orders";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processOrders(_response);
        });
    }
    processOrders(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(OrderWithRecipesAndExtras.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get Single Order
     * @param promoCode (optional)
     */
    orderWeekSubscriptionNumber(targetWeek, subscriptionNumber, promoCode) {
        let url_ = this.baseUrl + "/order/week/{targetWeek}/subscriptionNumber/{subscriptionNumber}?";
        if (targetWeek === undefined || targetWeek === null)
            throw new Error("The parameter 'targetWeek' must be defined.");
        url_ = url_.replace("{targetWeek}", encodeURIComponent(targetWeek ? "" + targetWeek.toISOString() : "null"));
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processOrderWeekSubscriptionNumber(_response);
        });
    }
    processOrderWeekSubscriptionNumber(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SingleOrderWithRecipesAndExtras.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Product Extras - Get Suggested Extras Given A Sku
     * @return OK
     */
    productsExtrasSuggestion(sku, week) {
        let url_ = this.baseUrl + "/products/{sku}/extras/suggestion/{week}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProductsExtrasSuggestion(_response);
        });
    }
    processProductsExtrasSuggestion(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(AccountProductSummary.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to load suggested extras", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Products - Get product details by SKU and week
     * @param promoCode (optional)
     * @return OK
     */
    productsWeek(sku, week, promoCode) {
        let url_ = this.baseUrl + "/products/{sku}/week/{week}?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProductsWeek(_response);
        });
    }
    processProductsWeek(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductAndRecipeDetailsResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to product details", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Extras Products Details - Get extras product details by SKU and week
     * @param promoCode (optional)
     * @return OK
     */
    productsExtrasDetails(sku, week, promoCode) {
        let url_ = this.baseUrl + "/products/extras/details/{sku}/{week}?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProductsExtrasDetails(_response);
        });
    }
    processProductsExtrasDetails(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ExtraDetailResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to get product extras details", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Product Extras - Get the Available Extras Given A Sku
     * @param promoCode (optional)
     * @return OK
     */
    productsExtrasAvailable(sku, week, promoCode) {
        let url_ = this.baseUrl + "/products/{sku}/extras/available/{week}?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProductsExtrasAvailable(_response);
        });
    }
    processProductsExtrasAvailable(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AvailableExtrasResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to load available extras", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Products - Get marketing groups
     * @return OK
     */
    productsGroupedMarketing() {
        let url_ = this.baseUrl + "/products/grouped/marketing";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processProductsGroupedMarketing(_response);
        });
    }
    processProductsGroupedMarketing(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(ProductGroupResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to load products, grouped for marketing", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Recipes - Get details for a recipe.
     * @return OK
    or
     */
    recipe(partition, recipeNumber, version, week) {
        let url_ = this.baseUrl + "/recipe/{partition}/{recipeNumber}/{version}/{week}";
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition));
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRecipe(_response);
        });
    }
    processRecipe(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = RecipeResponse2.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to retrieve Recipe Details", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Recipe Filters - Get details of filters and recipe under filters.
     * @return OK
    or
     */
    recipesFiltered(sku, week) {
        let url_ = this.baseUrl + "/recipes/filtered/{sku}/{week}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processRecipesFiltered(_response);
        });
    }
    processRecipesFiltered(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = FiltersResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to retrieve Filter and Recipe Details", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sales - Forecast search by week range
     */
    salesForecastSearch(startWeek, endWeek) {
        let url_ = this.baseUrl + "/sales/forecast/search/{startWeek}/{endWeek}";
        if (startWeek === undefined || startWeek === null)
            throw new Error("The parameter 'startWeek' must be defined.");
        url_ = url_.replace("{startWeek}", encodeURIComponent(startWeek ? "" + startWeek.toISOString() : "null"));
        if (endWeek === undefined || endWeek === null)
            throw new Error("The parameter 'endWeek' must be defined.");
        url_ = url_.replace("{endWeek}", encodeURIComponent(endWeek ? "" + endWeek.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSalesForecastSearch(_response);
        });
    }
    processSalesForecastSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(OrderResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sales - Single forecasted delivery
     * @param promoCode (optional)
     */
    salesForecastSingle(targetWeek, subscriptionNumber, promoCode) {
        let url_ = this.baseUrl + "/sales/forecast/single/{targetWeek}/{subscriptionNumber}?";
        if (targetWeek === undefined || targetWeek === null)
            throw new Error("The parameter 'targetWeek' must be defined.");
        url_ = url_.replace("{targetWeek}", encodeURIComponent(targetWeek ? "" + targetWeek.toISOString() : "null"));
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        if (promoCode !== undefined && promoCode !== null)
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSalesForecastSingle(_response);
        });
    }
    processSalesForecastSingle(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SingleForecastResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sales - Order search by week range
     */
    salesOrdersSearch(startWeek, endWeek) {
        let url_ = this.baseUrl + "/sales/orders/search/{startWeek}/{endWeek}";
        if (startWeek === undefined || startWeek === null)
            throw new Error("The parameter 'startWeek' must be defined.");
        url_ = url_.replace("{startWeek}", encodeURIComponent(startWeek ? "" + startWeek.toISOString() : "null"));
        if (endWeek === undefined || endWeek === null)
            throw new Error("The parameter 'endWeek' must be defined.");
        url_ = url_.replace("{endWeek}", encodeURIComponent(endWeek ? "" + endWeek.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSalesOrdersSearch(_response);
        });
    }
    processSalesOrdersSearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(OrderResponse.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sales - Validates then fetches the promo details
     * @deprecated
     */
    salesDiscountPromo(promoCode, productSku) {
        let url_ = this.baseUrl + "/sales/discount/promo/{promoCode}/{productSku}";
        if (promoCode === undefined || promoCode === null)
            throw new Error("The parameter 'promoCode' must be defined.");
        url_ = url_.replace("{promoCode}", encodeURIComponent("" + promoCode));
        if (productSku === undefined || productSku === null)
            throw new Error("The parameter 'productSku' must be defined.");
        url_ = url_.replace("{productSku}", encodeURIComponent("" + productSku));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSalesDiscountPromo(_response);
        });
    }
    processSalesDiscountPromo(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ValidatePromoResultResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    salesPromoValidateWeekSubscription(targetWeek, promoCode, subscriptionNumber) {
        let url_ = this.baseUrl + "/sales/promo/validate/{promoCode}/week/{targetWeek}/subscription/{subscriptionNumber}";
        if (targetWeek === undefined || targetWeek === null)
            throw new Error("The parameter 'targetWeek' must be defined.");
        url_ = url_.replace("{targetWeek}", encodeURIComponent(targetWeek ? "" + targetWeek.toISOString() : "null"));
        if (promoCode === undefined || promoCode === null)
            throw new Error("The parameter 'promoCode' must be defined.");
        url_ = url_.replace("{promoCode}", encodeURIComponent("" + promoCode));
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSalesPromoValidateWeekSubscription(_response);
        });
    }
    processSalesPromoValidateWeekSubscription(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PromoOverride.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    validateCode(code, sku) {
        let url_ = this.baseUrl + "/validateCode/{code}/{sku}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processValidateCode(_response);
        });
    }
    processValidateCode(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CodeValidationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * DeliveryCalendar
     */
    calendar() {
        let url_ = this.baseUrl + "/calendar";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processCalendar(_response);
        });
    }
    processCalendar(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CalendarResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sales - Update shipping details for order
     * @param body (optional) Request body
     */
    salesOrderShipping(body) {
        let url_ = this.baseUrl + "/sales/order/shipping";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSalesOrderShipping(_response);
        });
    }
    processSalesOrderShipping(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = UpdateDeliveryShippingResponseDto.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Sales - Shipping Delivery Dates
     * @param body (optional) Request body
     */
    salesOrderShippingDeliverydates(body) {
        let url_ = this.baseUrl + "/sales/order/shipping/deliverydates";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSalesOrderShippingDeliverydates(_response);
        });
    }
    processSalesOrderShippingDeliverydates(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = DeliveryDatesResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Account - Create Subscription
     * @param body (optional) Create subscription request body
     */
    subscriptionsCreate(body) {
        let url_ = this.baseUrl + "/subscriptions/create";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsCreate(_response);
        });
    }
    processSubscriptionsCreate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Subscriptions - Update Subscription
     * @param body (optional) Request body
     */
    subscriptions(subscriptionNumber, body) {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionNumber}";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptions(_response);
        });
    }
    processSubscriptions(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountUpdateSubscriptionResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Subscriptions - Plan Your Week Update
     * @param body (optional) Update from Plan Your Week request body
     */
    subscriptionsPlanyourweek(subscriptionNumber, week, body) {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionNumber}/planyourweek/{week}";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsPlanyourweek(_response);
        });
    }
    processSubscriptionsPlanyourweek(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountUpdatePlanYourWeekResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Subscriptions - Calculate Subscription Cost
     * @param body (optional)
     */
    subscriptionsCostCalculate(week, body) {
        let url_ = this.baseUrl + "/subscriptions/cost/calculate/{week}";
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsCostCalculate(_response);
        });
    }
    processSubscriptionsCostCalculate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CostPreviewResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Subscriptions - Validate a Product Change
     * @param body (optional)
     */
    subscriptionsProductValidate(subscriptionNumber, body) {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionNumber}/product/validate";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsProductValidate(_response);
        });
    }
    processSubscriptionsProductValidate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = AccountValidateProductChangeResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Subscriptions - Skip sub
     * @param body (optional)
     */
    subscriptionsSkip(subscriptionNumber, body) {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionNumber}/skip";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsSkip(_response);
        });
    }
    processSubscriptionsSkip(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Result.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Subscriptions - un-skip sub
     * @param body (optional)
     */
    subscriptionsUnSkip(subscriptionNumber, body) {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionNumber}/un-skip";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsUnSkip(_response);
        });
    }
    processSubscriptionsUnSkip(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = Result.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Subscriptions - Cancel sub
     * @param body (optional)
     */
    subscriptionsCancel(subscriptionNumber, body) {
        let url_ = this.baseUrl + "/subscriptions/{subscriptionNumber}/cancel";
        if (subscriptionNumber === undefined || subscriptionNumber === null)
            throw new Error("The parameter 'subscriptionNumber' must be defined.");
        url_ = url_.replace("{subscriptionNumber}", encodeURIComponent("" + subscriptionNumber));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processSubscriptionsCancel(_response);
        });
    }
    processSubscriptionsCancel(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CancelSubscriptionResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Tracking - Get Tracking Metadata for User
     * @return OK
     */
    trackingMe() {
        let url_ = this.baseUrl + "/tracking/me";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTrackingMe(_response);
        });
    }
    processTrackingMe(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    for (let item of resultData200)
                        result200.push(SubscriptionTrackingMetadata.fromJS(item));
                }
                else {
                    result200 = null;
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Translation - Get locale translation
     * @return OK
     */
    translations(locale, namespace) {
        let url_ = this.baseUrl + "/translations/{locale}/{namespace}";
        if (locale === undefined || locale === null)
            throw new Error("The parameter 'locale' must be defined.");
        url_ = url_.replace("{locale}", encodeURIComponent("" + locale));
        if (namespace === undefined || namespace === null)
            throw new Error("The parameter 'namespace' must be defined.");
        url_ = url_.replace("{namespace}", encodeURIComponent("" + namespace));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };
        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response) => {
            return this.processTranslations(_response);
        });
    }
    processTranslations(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = resultData400 !== undefined ? resultData400 : null;
                return throwException("Failed to get translation", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
export class AddressSuggestionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.suggestionId = _data["suggestionId"];
            this.fullAddress = _data["fullAddress"];
            this.isExistingAddress = _data["isExistingAddress"];
            this.deliveryInstructions = _data["deliveryInstructions"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddressSuggestionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["suggestionId"] = this.suggestionId;
        data["fullAddress"] = this.fullAddress;
        data["isExistingAddress"] = this.isExistingAddress;
        data["deliveryInstructions"] = this.deliveryInstructions;
        return data;
    }
}
export class AddCustomerHolidayAddressRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliverySlotId = _data["deliverySlotId"];
            this.addressSuggestionId = _data["addressSuggestionId"];
            this.startDeliveryDate = _data["startDeliveryDate"] ? new Date(_data["startDeliveryDate"].toString()) : undefined;
            this.endDeliveryDate = _data["endDeliveryDate"] ? new Date(_data["endDeliveryDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddCustomerHolidayAddressRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliverySlotId"] = this.deliverySlotId;
        data["addressSuggestionId"] = this.addressSuggestionId;
        data["startDeliveryDate"] = this.startDeliveryDate ? this.startDeliveryDate.toISOString() : undefined;
        data["endDeliveryDate"] = this.endDeliveryDate ? this.endDeliveryDate.toISOString() : undefined;
        return data;
    }
}
export class GetCustomerAddressHolidayInformationResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.holidayAddress = _data["holidayAddress"];
            this.defaultAddress = _data["defaultAddress"];
            this.holidayDeliverySlot = _data["holidayDeliverySlot"];
            this.firstHolidayDeliveryDate = _data["firstHolidayDeliveryDate"] ? new Date(_data["firstHolidayDeliveryDate"].toString()) : undefined;
            this.lastHolidayDeliveryDate = _data["lastHolidayDeliveryDate"] ? new Date(_data["lastHolidayDeliveryDate"].toString()) : undefined;
            this.lastDeliveryDateToOriginalAddress = _data["lastDeliveryDateToOriginalAddress"] ? new Date(_data["lastDeliveryDateToOriginalAddress"].toString()) : undefined;
            this.resumingDeliveryDateToDefaultAddress = _data["resumingDeliveryDateToDefaultAddress"] ? new Date(_data["resumingDeliveryDateToDefaultAddress"].toString()) : undefined;
            this.holidayDeliveryPeriodMessage = _data["holidayDeliveryPeriodMessage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerAddressHolidayInformationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["holidayAddress"] = this.holidayAddress;
        data["defaultAddress"] = this.defaultAddress;
        data["holidayDeliverySlot"] = this.holidayDeliverySlot;
        data["firstHolidayDeliveryDate"] = this.firstHolidayDeliveryDate ? this.firstHolidayDeliveryDate.toISOString() : undefined;
        data["lastHolidayDeliveryDate"] = this.lastHolidayDeliveryDate ? this.lastHolidayDeliveryDate.toISOString() : undefined;
        data["lastDeliveryDateToOriginalAddress"] = this.lastDeliveryDateToOriginalAddress ? this.lastDeliveryDateToOriginalAddress.toISOString() : undefined;
        data["resumingDeliveryDateToDefaultAddress"] = this.resumingDeliveryDateToDefaultAddress ? this.resumingDeliveryDateToDefaultAddress.toISOString() : undefined;
        data["holidayDeliveryPeriodMessage"] = this.holidayDeliveryPeriodMessage;
        return data;
    }
}
export class GetCustomerAddressHolidayPreviewResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.defaultAddress = _data["defaultAddress"];
            this.firstHolidayDeliveryDate = _data["firstHolidayDeliveryDate"] ? new Date(_data["firstHolidayDeliveryDate"].toString()) : undefined;
            this.lastHolidayDeliveryDate = _data["lastHolidayDeliveryDate"] ? new Date(_data["lastHolidayDeliveryDate"].toString()) : undefined;
            this.lastDeliveryDateToOriginalAddress = _data["lastDeliveryDateToOriginalAddress"] ? new Date(_data["lastDeliveryDateToOriginalAddress"].toString()) : undefined;
            this.resumingDeliveryDateToDefaultAddress = _data["resumingDeliveryDateToDefaultAddress"] ? new Date(_data["resumingDeliveryDateToDefaultAddress"].toString()) : undefined;
            this.holidayDeliveryPeriodMessage = _data["holidayDeliveryPeriodMessage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerAddressHolidayPreviewResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["defaultAddress"] = this.defaultAddress;
        data["firstHolidayDeliveryDate"] = this.firstHolidayDeliveryDate ? this.firstHolidayDeliveryDate.toISOString() : undefined;
        data["lastHolidayDeliveryDate"] = this.lastHolidayDeliveryDate ? this.lastHolidayDeliveryDate.toISOString() : undefined;
        data["lastDeliveryDateToOriginalAddress"] = this.lastDeliveryDateToOriginalAddress ? this.lastDeliveryDateToOriginalAddress.toISOString() : undefined;
        data["resumingDeliveryDateToDefaultAddress"] = this.resumingDeliveryDateToDefaultAddress ? this.resumingDeliveryDateToDefaultAddress.toISOString() : undefined;
        data["holidayDeliveryPeriodMessage"] = this.holidayDeliveryPeriodMessage;
        return data;
    }
}
export class GetCustomerAddressHolidayPreviewRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.preferredDeliverySlotId = _data["preferredDeliverySlotId"];
            this.selectedStartDeliveryDate = _data["selectedStartDeliveryDate"] ? new Date(_data["selectedStartDeliveryDate"].toString()) : undefined;
            this.selectedEndDeliveryDate = _data["selectedEndDeliveryDate"] ? new Date(_data["selectedEndDeliveryDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerAddressHolidayPreviewRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["preferredDeliverySlotId"] = this.preferredDeliverySlotId;
        data["selectedStartDeliveryDate"] = this.selectedStartDeliveryDate ? this.selectedStartDeliveryDate.toISOString() : undefined;
        data["selectedEndDeliveryDate"] = this.selectedEndDeliveryDate ? this.selectedEndDeliveryDate.toISOString() : undefined;
        return data;
    }
}
export class ValidateAddressResponseDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.isValid = _data["isValid"];
            this.errorMessage = _data["errorMessage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAddressResponseDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["isValid"] = this.isValid;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}
export class ValidateAddressCommand {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.addressSuggestionId = _data["addressSuggestionId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateAddressCommand();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressSuggestionId"] = this.addressSuggestionId;
        return data;
    }
}
export class ValidateDeliveryAddressDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.isValid = _data["isValid"];
            this.errorMessage = _data["errorMessage"];
            this.errorType = _data["errorType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateDeliveryAddressDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["isValid"] = this.isValid;
        data["errorMessage"] = this.errorMessage;
        data["errorType"] = this.errorType;
        return data;
    }
}
export var ValidateDeliveryAddressErrorType;
(function (ValidateDeliveryAddressErrorType) {
    ValidateDeliveryAddressErrorType[ValidateDeliveryAddressErrorType["IslandsRestriction"] = 0] = "IslandsRestriction";
    ValidateDeliveryAddressErrorType[ValidateDeliveryAddressErrorType["CapacityLimits"] = 1] = "CapacityLimits";
    ValidateDeliveryAddressErrorType[ValidateDeliveryAddressErrorType["DeliveryNotFound"] = 2] = "DeliveryNotFound";
    ValidateDeliveryAddressErrorType[ValidateDeliveryAddressErrorType["DeliveryIsLocked"] = 3] = "DeliveryIsLocked";
    ValidateDeliveryAddressErrorType[ValidateDeliveryAddressErrorType["AddressChangeNotAvailable"] = 4] = "AddressChangeNotAvailable";
})(ValidateDeliveryAddressErrorType || (ValidateDeliveryAddressErrorType = {}));
export class ValidateDeliveryAddressRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.addressSuggestionId = _data["addressSuggestionId"];
            this.deliveryId = _data["deliveryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidateDeliveryAddressRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressSuggestionId"] = this.addressSuggestionId;
        data["deliveryId"] = this.deliveryId;
        return data;
    }
}
export class AddressChangedRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.currentAddressId = _data["currentAddressId"];
            this.newAddressId = _data["newAddressId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddressChangedRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["currentAddressId"] = this.currentAddressId;
        data["newAddressId"] = this.newAddressId;
        return data;
    }
}
export class EnrolledCampaignDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.campaignName = _data["campaignName"];
            this.joinUrl = _data["joinUrl"];
            this.joinTitle = _data["joinTitle"];
            this.joinDescription = _data["joinDescription"];
            this.enrolmentStart = _data["enrolmentStart"] ? new Date(_data["enrolmentStart"].toString()) : undefined;
            this.enrolmentEnd = _data["enrolmentEnd"] ? new Date(_data["enrolmentEnd"].toString()) : undefined;
            if (Array.isArray(_data["campaignPrizes"])) {
                this.campaignPrizes = [];
                for (let item of _data["campaignPrizes"])
                    this.campaignPrizes.push(CampaignPrizeSelectionsDto.fromJS(item));
            }
            this.displayPrize = _data["displayPrize"] ? CampaignPrizeSelectionsDto.fromJS(_data["displayPrize"]) : undefined;
            this.displayCelebration = _data["displayCelebration"];
            this.rewardApplied = _data["rewardApplied"];
            this.progressionText = _data["progressionText"];
            this.canChangePrizeSelection = _data["canChangePrizeSelection"];
            this.changePrizeUrl = _data["changePrizeUrl"];
            this.theme = _data["theme"];
            this.deliveryWeekStart = _data["deliveryWeekStart"] ? new Date(_data["deliveryWeekStart"].toString()) : undefined;
            this.deliveryWeekEnd = _data["deliveryWeekEnd"] ? new Date(_data["deliveryWeekEnd"].toString()) : undefined;
            this.campaignButtonText = _data["campaignButtonText"];
            this.drawerHeader = _data["drawerHeader"];
            this.drawerBody = _data["drawerBody"];
            this.progressionTowardsNextCampaignPrize = _data["progressionTowardsNextCampaignPrize"] ? NextCampaignPrizeProgression.fromJS(_data["progressionTowardsNextCampaignPrize"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EnrolledCampaignDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["joinUrl"] = this.joinUrl;
        data["joinTitle"] = this.joinTitle;
        data["joinDescription"] = this.joinDescription;
        data["enrolmentStart"] = this.enrolmentStart ? this.enrolmentStart.toISOString() : undefined;
        data["enrolmentEnd"] = this.enrolmentEnd ? this.enrolmentEnd.toISOString() : undefined;
        if (Array.isArray(this.campaignPrizes)) {
            data["campaignPrizes"] = [];
            for (let item of this.campaignPrizes)
                data["campaignPrizes"].push(item.toJSON());
        }
        data["displayPrize"] = this.displayPrize ? this.displayPrize.toJSON() : undefined;
        data["displayCelebration"] = this.displayCelebration;
        data["rewardApplied"] = this.rewardApplied;
        data["progressionText"] = this.progressionText;
        data["canChangePrizeSelection"] = this.canChangePrizeSelection;
        data["changePrizeUrl"] = this.changePrizeUrl;
        data["theme"] = this.theme;
        data["deliveryWeekStart"] = this.deliveryWeekStart ? this.deliveryWeekStart.toISOString() : undefined;
        data["deliveryWeekEnd"] = this.deliveryWeekEnd ? this.deliveryWeekEnd.toISOString() : undefined;
        data["campaignButtonText"] = this.campaignButtonText;
        data["drawerHeader"] = this.drawerHeader;
        data["drawerBody"] = this.drawerBody;
        data["progressionTowardsNextCampaignPrize"] = this.progressionTowardsNextCampaignPrize ? this.progressionTowardsNextCampaignPrize.toJSON() : undefined;
        return data;
    }
}
export class CampaignPrizeSelectionsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.numberOfDeliveriesRequired = _data["numberOfDeliveriesRequired"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.promoCode = _data["promoCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignPrizeSelectionsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["numberOfDeliveriesRequired"] = this.numberOfDeliveriesRequired;
        data["name"] = this.name;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["promoCode"] = this.promoCode;
        return data;
    }
}
export var CampaignTheme;
(function (CampaignTheme) {
    CampaignTheme[CampaignTheme["Standard"] = 0] = "Standard";
    CampaignTheme[CampaignTheme["TickerTape"] = 1] = "TickerTape";
})(CampaignTheme || (CampaignTheme = {}));
export class NextCampaignPrizeProgression {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.progress = _data["progress"];
            this.target = _data["target"];
            this.isProgressIndicatorHidden = _data["isProgressIndicatorHidden"];
            this.delta = _data["delta"];
            this.deltaToEarnReward = _data["deltaToEarnReward"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NextCampaignPrizeProgression();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["progress"] = this.progress;
        data["target"] = this.target;
        data["isProgressIndicatorHidden"] = this.isProgressIndicatorHidden;
        data["delta"] = this.delta;
        data["deltaToEarnReward"] = this.deltaToEarnReward;
        return data;
    }
}
export class EligibleCampaignDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.campaignCode = _data["campaignCode"];
            this.enrolmentStart = _data["enrolmentStart"] ? new Date(_data["enrolmentStart"].toString()) : undefined;
            this.enrolmentEnd = _data["enrolmentEnd"] ? new Date(_data["enrolmentEnd"].toString()) : undefined;
            this.campaignName = _data["campaignName"];
            this.joinUrl = _data["joinUrl"];
            this.joinTitle = _data["joinTitle"];
            this.joinDescription = _data["joinDescription"];
            this.imageUrl = _data["imageUrl"];
            this.imageUrlMedium = _data["imageUrlMedium"];
            this.imageUrlLarge = _data["imageUrlLarge"];
            this.isPromoted = _data["isPromoted"];
            this.campaignDescription = _data["campaignDescription"];
            this.theme = _data["theme"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EligibleCampaignDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["campaignCode"] = this.campaignCode;
        data["enrolmentStart"] = this.enrolmentStart ? this.enrolmentStart.toISOString() : undefined;
        data["enrolmentEnd"] = this.enrolmentEnd ? this.enrolmentEnd.toISOString() : undefined;
        data["campaignName"] = this.campaignName;
        data["joinUrl"] = this.joinUrl;
        data["joinTitle"] = this.joinTitle;
        data["joinDescription"] = this.joinDescription;
        data["imageUrl"] = this.imageUrl;
        data["imageUrlMedium"] = this.imageUrlMedium;
        data["imageUrlLarge"] = this.imageUrlLarge;
        data["isPromoted"] = this.isPromoted;
        data["campaignDescription"] = this.campaignDescription;
        data["theme"] = this.theme;
        return data;
    }
}
export class CampaignGroupDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [];
                for (let item of _data["campaigns"])
                    this.campaigns.push(GroupedCampaignDto.fromJS(item));
            }
            this.groupTitle = _data["groupTitle"];
            this.groupDescription = _data["groupDescription"];
            this.campaignParticipationStatus = _data["campaignParticipationStatus"];
            if (Array.isArray(_data["campaignGroupProductOptionIds"])) {
                this.campaignGroupProductOptionIds = [];
                for (let item of _data["campaignGroupProductOptionIds"])
                    this.campaignGroupProductOptionIds.push(item);
            }
            if (Array.isArray(_data["editableSubscriptions"])) {
                this.editableSubscriptions = [];
                for (let item of _data["editableSubscriptions"])
                    this.editableSubscriptions.push(CustomersEditableSubscriptionsDto.fromJS(item));
            }
            this.enrolmentStart = _data["enrolmentStart"] ? new Date(_data["enrolmentStart"].toString()) : undefined;
            this.enrolmentEnd = _data["enrolmentEnd"] ? new Date(_data["enrolmentEnd"].toString()) : undefined;
            this.isPromoted = _data["isPromoted"];
            this.theme = _data["theme"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignGroupDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item.toJSON());
        }
        data["groupTitle"] = this.groupTitle;
        data["groupDescription"] = this.groupDescription;
        data["campaignParticipationStatus"] = this.campaignParticipationStatus;
        if (Array.isArray(this.campaignGroupProductOptionIds)) {
            data["campaignGroupProductOptionIds"] = [];
            for (let item of this.campaignGroupProductOptionIds)
                data["campaignGroupProductOptionIds"].push(item);
        }
        if (Array.isArray(this.editableSubscriptions)) {
            data["editableSubscriptions"] = [];
            for (let item of this.editableSubscriptions)
                data["editableSubscriptions"].push(item.toJSON());
        }
        data["enrolmentStart"] = this.enrolmentStart ? this.enrolmentStart.toISOString() : undefined;
        data["enrolmentEnd"] = this.enrolmentEnd ? this.enrolmentEnd.toISOString() : undefined;
        data["isPromoted"] = this.isPromoted;
        data["theme"] = this.theme;
        return data;
    }
}
export class GroupedCampaignDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.campaignName = _data["campaignName"];
            this.campaignCode = _data["campaignCode"];
            this.marketing = _data["marketing"] ? GroupedCampaignMarketingDto.fromJS(_data["marketing"]) : undefined;
            if (Array.isArray(_data["campaignTiers"])) {
                this.campaignTiers = [];
                for (let item of _data["campaignTiers"])
                    this.campaignTiers.push(CampaignTierDto.fromJS(item));
            }
            if (Array.isArray(_data["prizeSelections"])) {
                this.prizeSelections = [];
                for (let item of _data["prizeSelections"])
                    this.prizeSelections.push(CampaignSelectionDto.fromJS(item));
            }
            this.imageUrl = _data["imageUrl"];
            this.imageUrlMedium = _data["imageUrlMedium"];
            this.imageUrlLarge = _data["imageUrlLarge"];
            this.remainingDeliveryWeeks = _data["remainingDeliveryWeeks"];
            this.campaignSortOrder = _data["campaignSortOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedCampaignDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["campaignName"] = this.campaignName;
        data["campaignCode"] = this.campaignCode;
        data["marketing"] = this.marketing ? this.marketing.toJSON() : undefined;
        if (Array.isArray(this.campaignTiers)) {
            data["campaignTiers"] = [];
            for (let item of this.campaignTiers)
                data["campaignTiers"].push(item.toJSON());
        }
        if (Array.isArray(this.prizeSelections)) {
            data["prizeSelections"] = [];
            for (let item of this.prizeSelections)
                data["prizeSelections"].push(item.toJSON());
        }
        data["imageUrl"] = this.imageUrl;
        data["imageUrlMedium"] = this.imageUrlMedium;
        data["imageUrlLarge"] = this.imageUrlLarge;
        data["remainingDeliveryWeeks"] = this.remainingDeliveryWeeks;
        data["campaignSortOrder"] = this.campaignSortOrder;
        return data;
    }
}
export class GroupedCampaignMarketingDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            if (Array.isArray(_data["claims"])) {
                this.claims = [];
                for (let item of _data["claims"])
                    this.claims.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedCampaignMarketingDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            for (let item of this.claims)
                data["claims"].push(item);
        }
        return data;
    }
}
export class CampaignTierDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.campaignPrizes = [];
        }
    }
    init(_data) {
        if (_data) {
            this.campaignTierId = _data["campaignTierId"];
            if (Array.isArray(_data["campaignPrizes"])) {
                this.campaignPrizes = [];
                for (let item of _data["campaignPrizes"])
                    this.campaignPrizes.push(CampaignPrizeDto.fromJS(item));
            }
            this.deliveriesRequired = _data["deliveriesRequired"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignTierDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["campaignTierId"] = this.campaignTierId;
        if (Array.isArray(this.campaignPrizes)) {
            data["campaignPrizes"] = [];
            for (let item of this.campaignPrizes)
                data["campaignPrizes"].push(item.toJSON());
        }
        data["deliveriesRequired"] = this.deliveriesRequired;
        return data;
    }
}
export class CampaignPrizeDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.campaignPrizeId = _data["campaignPrizeId"];
            this.name = _data["name"];
            this.imageUrl = _data["imageUrl"];
            this.sku = _data["sku"];
            this.isSoldOut = _data["isSoldOut"];
            this.promoGroupCode = _data["promoGroupCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignPrizeDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["campaignPrizeId"] = this.campaignPrizeId;
        data["name"] = this.name;
        data["imageUrl"] = this.imageUrl;
        data["sku"] = this.sku;
        data["isSoldOut"] = this.isSoldOut;
        data["promoGroupCode"] = this.promoGroupCode;
        return data;
    }
}
export class CampaignSelectionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.campaignTierId = _data["campaignTierId"];
            this.campaignPrizeId = _data["campaignPrizeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignSelectionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["campaignTierId"] = this.campaignTierId;
        data["campaignPrizeId"] = this.campaignPrizeId;
        return data;
    }
}
export var CampaignParticipationStatus;
(function (CampaignParticipationStatus) {
    CampaignParticipationStatus[CampaignParticipationStatus["CampaignIsJoinable"] = 0] = "CampaignIsJoinable";
    CampaignParticipationStatus[CampaignParticipationStatus["CustomerIsInThisCampaign"] = 1] = "CustomerIsInThisCampaign";
    CampaignParticipationStatus[CampaignParticipationStatus["CampaignCodeIsNotValid"] = 2] = "CampaignCodeIsNotValid";
    CampaignParticipationStatus[CampaignParticipationStatus["CampaignHasNotStarted"] = 3] = "CampaignHasNotStarted";
    CampaignParticipationStatus[CampaignParticipationStatus["CampaignHasEnded"] = 4] = "CampaignHasEnded";
    CampaignParticipationStatus[CampaignParticipationStatus["CampaignIsFull"] = 5] = "CampaignIsFull";
    CampaignParticipationStatus[CampaignParticipationStatus["CustomerIsInSiblingCampaign"] = 6] = "CustomerIsInSiblingCampaign";
    CampaignParticipationStatus[CampaignParticipationStatus["CustomerDoesNotHaveActiveSubscription"] = 7] = "CustomerDoesNotHaveActiveSubscription";
    CampaignParticipationStatus[CampaignParticipationStatus["ProductOptionIsNotWhitelisted"] = 8] = "ProductOptionIsNotWhitelisted";
    CampaignParticipationStatus[CampaignParticipationStatus["CustomerIsInAnotherCampaign"] = 9] = "CustomerIsInAnotherCampaign";
})(CampaignParticipationStatus || (CampaignParticipationStatus = {}));
export class CustomersEditableSubscriptionsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.productName = _data["productName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomersEditableSubscriptionsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["productName"] = this.productName;
        return data;
    }
}
export class CampaignJoinResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["errorMessages"])) {
                this.errorMessages = [];
                for (let item of _data["errorMessages"])
                    this.errorMessages.push(item);
            }
            this.firstDeliveryWeek = _data["firstDeliveryWeek"] ? new Date(_data["firstDeliveryWeek"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignJoinResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.errorMessages)) {
            data["errorMessages"] = [];
            for (let item of this.errorMessages)
                data["errorMessages"].push(item);
        }
        data["firstDeliveryWeek"] = this.firstDeliveryWeek ? this.firstDeliveryWeek.toISOString() : undefined;
        return data;
    }
}
export class JoinCampaignCommandBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["campaignSelections"])) {
                this.campaignSelections = [];
                for (let item of _data["campaignSelections"])
                    this.campaignSelections.push(CampaignSelection.fromJS(item));
            }
            this.campaignCode = _data["campaignCode"];
            this.firstDeliveryWeek = _data["firstDeliveryWeek"] ? new Date(_data["firstDeliveryWeek"].toString()) : undefined;
            this.isAutoEnrolled = _data["isAutoEnrolled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new JoinCampaignCommandBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.campaignSelections)) {
            data["campaignSelections"] = [];
            for (let item of this.campaignSelections)
                data["campaignSelections"].push(item.toJSON());
        }
        data["campaignCode"] = this.campaignCode;
        data["firstDeliveryWeek"] = this.firstDeliveryWeek ? this.firstDeliveryWeek.toISOString() : undefined;
        data["isAutoEnrolled"] = this.isAutoEnrolled;
        return data;
    }
}
export class CampaignSelection {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.campaignTierId = _data["campaignTierId"];
            this.campaignPrizeId = _data["campaignPrizeId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CampaignSelection();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["campaignTierId"] = this.campaignTierId;
        data["campaignPrizeId"] = this.campaignPrizeId;
        return data;
    }
}
export class CustomerTriggerResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["triggerCodes"])) {
                this.triggerCodes = [];
                for (let item of _data["triggerCodes"])
                    this.triggerCodes.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerTriggerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.triggerCodes)) {
            data["triggerCodes"] = [];
            for (let item of this.triggerCodes)
                data["triggerCodes"].push(item);
        }
        return data;
    }
}
export class GetCustomerMessageResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.triggerCode = _data["triggerCode"];
            this.triggers = _data["triggers"] ? CustomerMessageTriggerWrapperResponse.fromJS(_data["triggers"]) : undefined;
            if (Array.isArray(_data["customerMessages"])) {
                this.customerMessages = [];
                for (let item of _data["customerMessages"])
                    this.customerMessages.push(CustomerMessageResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerMessageResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["triggerCode"] = this.triggerCode;
        data["triggers"] = this.triggers ? this.triggers.toJSON() : undefined;
        if (Array.isArray(this.customerMessages)) {
            data["customerMessages"] = [];
            for (let item of this.customerMessages)
                data["customerMessages"].push(item.toJSON());
        }
        return data;
    }
}
export class CustomerMessageTriggerWrapperResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            if (Array.isArray(_data["customerMessageTriggers"])) {
                this.customerMessageTriggers = [];
                for (let item of _data["customerMessageTriggers"])
                    this.customerMessageTriggers.push(CustomerMessageTriggerResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageTriggerWrapperResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        if (Array.isArray(this.customerMessageTriggers)) {
            data["customerMessageTriggers"] = [];
            for (let item of this.customerMessageTriggers)
                data["customerMessageTriggers"].push(item.toJSON());
        }
        return data;
    }
}
export class CustomerMessageTriggerResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerMessageTriggerId = _data["customerMessageTriggerId"];
            this.name = _data["name"];
            this.primaryCta = _data["primaryCta"] ? CustomerMessageActionResponse.fromJS(_data["primaryCta"]) : undefined;
            this.secondaryCta = _data["secondaryCta"] ? CustomerMessageActionResponse.fromJS(_data["secondaryCta"]) : undefined;
            this.sortOrder = _data["sortOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageTriggerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerMessageTriggerId"] = this.customerMessageTriggerId;
        data["name"] = this.name;
        data["primaryCta"] = this.primaryCta ? this.primaryCta.toJSON() : undefined;
        data["secondaryCta"] = this.secondaryCta ? this.secondaryCta.toJSON() : undefined;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}
export class CustomerMessageActionResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.text = _data["text"];
            this.url = _data["url"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageActionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["text"] = this.text;
        data["url"] = this.url;
        return data;
    }
}
export class CustomerMessageResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerMessageId = _data["customerMessageId"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.subtitle = _data["subtitle"];
            this.imageUrl = _data["imageUrl"];
            if (Array.isArray(_data["eligibleCustomerMessageTriggerIds"])) {
                this.eligibleCustomerMessageTriggerIds = [];
                for (let item of _data["eligibleCustomerMessageTriggerIds"])
                    this.eligibleCustomerMessageTriggerIds.push(item);
            }
            this.primaryCta = _data["primaryCta"] ? CustomerMessageActionResponse.fromJS(_data["primaryCta"]) : undefined;
            this.secondaryCta = _data["secondaryCta"] ? CustomerMessageActionResponse.fromJS(_data["secondaryCta"]) : undefined;
            this.colourScheme = _data["colourScheme"] ? CustomerMessageColourSchemeResponse.fromJS(_data["colourScheme"]) : undefined;
            this.termsAndConditions = _data["termsAndConditions"];
            this.internalMarketingDescription = _data["internalMarketingDescription"];
            this.internalPrimaryActionName = _data["internalPrimaryActionName"];
            this.internalSecondaryActionName = _data["internalSecondaryActionName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerMessageId"] = this.customerMessageId;
        data["title"] = this.title;
        data["body"] = this.body;
        data["subtitle"] = this.subtitle;
        data["imageUrl"] = this.imageUrl;
        if (Array.isArray(this.eligibleCustomerMessageTriggerIds)) {
            data["eligibleCustomerMessageTriggerIds"] = [];
            for (let item of this.eligibleCustomerMessageTriggerIds)
                data["eligibleCustomerMessageTriggerIds"].push(item);
        }
        data["primaryCta"] = this.primaryCta ? this.primaryCta.toJSON() : undefined;
        data["secondaryCta"] = this.secondaryCta ? this.secondaryCta.toJSON() : undefined;
        data["colourScheme"] = this.colourScheme ? this.colourScheme.toJSON() : undefined;
        data["termsAndConditions"] = this.termsAndConditions;
        data["internalMarketingDescription"] = this.internalMarketingDescription;
        data["internalPrimaryActionName"] = this.internalPrimaryActionName;
        data["internalSecondaryActionName"] = this.internalSecondaryActionName;
        return data;
    }
}
export class CustomerMessageColourSchemeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            this.backgroundHex = _data["backgroundHex"];
            this.textHex = _data["textHex"];
            this.accentHex = _data["accentHex"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageColourSchemeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["backgroundHex"] = this.backgroundHex;
        data["textHex"] = this.textHex;
        data["accentHex"] = this.accentHex;
        return data;
    }
}
export class GetCustomerMessageBulkResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.customerMessageResult = new GetCustomerMessageResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.deliveryDateId = _data["deliveryDateId"];
            this.deliveryWeek = _data["deliveryWeek"] ? new Date(_data["deliveryWeek"].toString()) : undefined;
            this.triggerCode = _data["triggerCode"];
            this.customerMessageResult = _data["customerMessageResult"] ? GetCustomerMessageResponse.fromJS(_data["customerMessageResult"]) : new GetCustomerMessageResponse();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerMessageBulkResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDateId"] = this.deliveryDateId;
        data["deliveryWeek"] = this.deliveryWeek ? this.deliveryWeek.toISOString() : undefined;
        data["triggerCode"] = this.triggerCode;
        data["customerMessageResult"] = this.customerMessageResult ? this.customerMessageResult.toJSON() : undefined;
        return data;
    }
}
export class GetCustomerMessageBulkRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionNumber = _data["subscriptionNumber"];
            if (Array.isArray(_data["triggerCodes"])) {
                this.triggerCodes = [];
                for (let item of _data["triggerCodes"])
                    this.triggerCodes.push(item);
            }
            if (Array.isArray(_data["deliveryDateIds"])) {
                this.deliveryDateIds = [];
                for (let item of _data["deliveryDateIds"])
                    this.deliveryDateIds.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerMessageBulkRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionNumber"] = this.subscriptionNumber;
        if (Array.isArray(this.triggerCodes)) {
            data["triggerCodes"] = [];
            for (let item of this.triggerCodes)
                data["triggerCodes"].push(item);
        }
        if (Array.isArray(this.deliveryDateIds)) {
            data["deliveryDateIds"] = [];
            for (let item of this.deliveryDateIds)
                data["deliveryDateIds"].push(item);
        }
        return data;
    }
}
export class GetCustomerMessageDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.triggers = _data["triggers"] ? CustomerMessageTriggerWrapperDto.fromJS(_data["triggers"]) : undefined;
            if (Array.isArray(_data["customerMessages"])) {
                this.customerMessages = [];
                for (let item of _data["customerMessages"])
                    this.customerMessages.push(CustomerMessageDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetCustomerMessageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["triggers"] = this.triggers ? this.triggers.toJSON() : undefined;
        if (Array.isArray(this.customerMessages)) {
            data["customerMessages"] = [];
            for (let item of this.customerMessages)
                data["customerMessages"].push(item.toJSON());
        }
        return data;
    }
}
export class CustomerMessageTriggerWrapperDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            if (Array.isArray(_data["customerMessageTriggers"])) {
                this.customerMessageTriggers = [];
                for (let item of _data["customerMessageTriggers"])
                    this.customerMessageTriggers.push(CustomerMessageTriggerDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageTriggerWrapperDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        if (Array.isArray(this.customerMessageTriggers)) {
            data["customerMessageTriggers"] = [];
            for (let item of this.customerMessageTriggers)
                data["customerMessageTriggers"].push(item.toJSON());
        }
        return data;
    }
}
export class CustomerMessageTriggerDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerMessageTriggerId = _data["customerMessageTriggerId"];
            this.name = _data["name"];
            this.triggerCode = _data["triggerCode"];
            this.messageTypeCode = _data["messageTypeCode"];
            this.description = _data["description"];
            this.primaryCta = _data["primaryCta"] ? CustomerMessageActionDto.fromJS(_data["primaryCta"]) : undefined;
            this.secondaryCta = _data["secondaryCta"] ? CustomerMessageActionDto.fromJS(_data["secondaryCta"]) : undefined;
            this.sortOrder = _data["sortOrder"];
            this.title = _data["title"];
            this.deviceTarget = _data["deviceTarget"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageTriggerDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerMessageTriggerId"] = this.customerMessageTriggerId;
        data["name"] = this.name;
        data["triggerCode"] = this.triggerCode;
        data["messageTypeCode"] = this.messageTypeCode;
        data["description"] = this.description;
        data["primaryCta"] = this.primaryCta ? this.primaryCta.toJSON() : undefined;
        data["secondaryCta"] = this.secondaryCta ? this.secondaryCta.toJSON() : undefined;
        data["sortOrder"] = this.sortOrder;
        data["title"] = this.title;
        data["deviceTarget"] = this.deviceTarget;
        return data;
    }
}
export class CustomerMessageActionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerMessageActionId = _data["customerMessageActionId"];
            this.text = _data["text"];
            this.url = _data["url"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageActionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerMessageActionId"] = this.customerMessageActionId;
        data["text"] = this.text;
        data["url"] = this.url;
        return data;
    }
}
export var DeviceTarget;
(function (DeviceTarget) {
    DeviceTarget[DeviceTarget["Web"] = 1] = "Web";
    DeviceTarget[DeviceTarget["Ios"] = 2] = "Ios";
    DeviceTarget[DeviceTarget["Android"] = 4] = "Android";
})(DeviceTarget || (DeviceTarget = {}));
export class CustomerMessageDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerMessageId = _data["customerMessageId"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.imageUrl = _data["imageUrl"];
            this.weekStarting = _data["weekStarting"] ? new Date(_data["weekStarting"].toString()) : undefined;
            this.weekEnding = _data["weekEnding"] ? new Date(_data["weekEnding"].toString()) : undefined;
            this.dateCreatedUTC = _data["dateCreatedUTC"] ? new Date(_data["dateCreatedUTC"].toString()) : undefined;
            this.deviceTarget = _data["deviceTarget"];
            this.marketingDescription = _data["marketingDescription"];
            this.promoGroupId = _data["promoGroupId"];
            this.sortOrder = _data["sortOrder"];
            this.messageTypeCode = _data["messageTypeCode"];
            if (Array.isArray(_data["rules"])) {
                this.rules = [];
                for (let item of _data["rules"])
                    this.rules.push(CustomerMessageTargetingRuleDto.fromJS(item));
            }
            if (Array.isArray(_data["eligibleCustomerMessageTriggerIds"])) {
                this.eligibleCustomerMessageTriggerIds = [];
                for (let item of _data["eligibleCustomerMessageTriggerIds"])
                    this.eligibleCustomerMessageTriggerIds.push(item);
            }
            this.primaryCta = _data["primaryCta"] ? CustomerMessageActionDto.fromJS(_data["primaryCta"]) : undefined;
            this.secondaryCta = _data["secondaryCta"] ? CustomerMessageActionDto.fromJS(_data["secondaryCta"]) : undefined;
            this.colourScheme = _data["colourScheme"] ? CustomerMessageColourSchemeDto.fromJS(_data["colourScheme"]) : undefined;
            this.termsAndConditions = _data["termsAndConditions"];
            this.internalMarketingDescription = _data["internalMarketingDescription"];
            this.internalPrimaryActionName = _data["internalPrimaryActionName"];
            this.internalSecondaryActionName = _data["internalSecondaryActionName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerMessageId"] = this.customerMessageId;
        data["title"] = this.title;
        data["body"] = this.body;
        data["imageUrl"] = this.imageUrl;
        data["weekStarting"] = this.weekStarting ? this.weekStarting.toISOString() : undefined;
        data["weekEnding"] = this.weekEnding ? this.weekEnding.toISOString() : undefined;
        data["dateCreatedUTC"] = this.dateCreatedUTC ? this.dateCreatedUTC.toISOString() : undefined;
        data["deviceTarget"] = this.deviceTarget;
        data["marketingDescription"] = this.marketingDescription;
        data["promoGroupId"] = this.promoGroupId;
        data["sortOrder"] = this.sortOrder;
        data["messageTypeCode"] = this.messageTypeCode;
        if (Array.isArray(this.rules)) {
            data["rules"] = [];
            for (let item of this.rules)
                data["rules"].push(item.toJSON());
        }
        if (Array.isArray(this.eligibleCustomerMessageTriggerIds)) {
            data["eligibleCustomerMessageTriggerIds"] = [];
            for (let item of this.eligibleCustomerMessageTriggerIds)
                data["eligibleCustomerMessageTriggerIds"].push(item);
        }
        data["primaryCta"] = this.primaryCta ? this.primaryCta.toJSON() : undefined;
        data["secondaryCta"] = this.secondaryCta ? this.secondaryCta.toJSON() : undefined;
        data["colourScheme"] = this.colourScheme ? this.colourScheme.toJSON() : undefined;
        data["termsAndConditions"] = this.termsAndConditions;
        data["internalMarketingDescription"] = this.internalMarketingDescription;
        data["internalPrimaryActionName"] = this.internalPrimaryActionName;
        data["internalSecondaryActionName"] = this.internalSecondaryActionName;
        return data;
    }
}
export class CustomerMessageTargetingRuleDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerMessageTargetingRuleId = _data["customerMessageTargetingRuleId"];
            this.ruleTypeCode = _data["ruleTypeCode"];
            this.value = _data["value"];
            this.customerMessageId = _data["customerMessageId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageTargetingRuleDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerMessageTargetingRuleId"] = this.customerMessageTargetingRuleId;
        data["ruleTypeCode"] = this.ruleTypeCode;
        data["value"] = this.value;
        data["customerMessageId"] = this.customerMessageId;
        return data;
    }
}
export class CustomerMessageColourSchemeDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.description = _data["description"];
            this.backgroundHex = _data["backgroundHex"];
            this.textHex = _data["textHex"];
            this.accentHex = _data["accentHex"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerMessageColourSchemeDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["backgroundHex"] = this.backgroundHex;
        data["textHex"] = this.textHex;
        data["accentHex"] = this.accentHex;
        return data;
    }
}
export class CustomerProfileResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerDetails = _data["customerDetails"] ? CustomerDetailsDto.fromJS(_data["customerDetails"]) : undefined;
            if (Array.isArray(_data["subscriptions"])) {
                this.subscriptions = [];
                for (let item of _data["subscriptions"])
                    this.subscriptions.push(CustomerProfileSubscriptionDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProfileResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerDetails"] = this.customerDetails ? this.customerDetails.toJSON() : undefined;
        if (Array.isArray(this.subscriptions)) {
            data["subscriptions"] = [];
            for (let item of this.subscriptions)
                data["subscriptions"].push(item.toJSON());
        }
        return data;
    }
}
export class CustomerDetailsDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.address = _data["address"] ? AddressDto.fromJS(_data["address"]) : undefined;
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.mobileNumber = _data["mobileNumber"];
            this.optOutRecipeCards = _data["optOutRecipeCards"];
            if (Array.isArray(_data["customerCredit"])) {
                this.customerCredit = [];
                for (let item of _data["customerCredit"])
                    this.customerCredit.push(CustomerCreditDto.fromJS(item));
            }
            if (Array.isArray(_data["paymentsDue"])) {
                this.paymentsDue = [];
                for (let item of _data["paymentsDue"])
                    this.paymentsDue.push(PaymentDueDto.fromJS(item));
            }
            if (Array.isArray(_data["vouchers"])) {
                this.vouchers = [];
                for (let item of _data["vouchers"])
                    this.vouchers.push(VoucherDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerDetailsDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["mobileNumber"] = this.mobileNumber;
        data["optOutRecipeCards"] = this.optOutRecipeCards;
        if (Array.isArray(this.customerCredit)) {
            data["customerCredit"] = [];
            for (let item of this.customerCredit)
                data["customerCredit"].push(item.toJSON());
        }
        if (Array.isArray(this.paymentsDue)) {
            data["paymentsDue"] = [];
            for (let item of this.paymentsDue)
                data["paymentsDue"].push(item.toJSON());
        }
        if (Array.isArray(this.vouchers)) {
            data["vouchers"] = [];
            for (let item of this.vouchers)
                data["vouchers"].push(item.toJSON());
        }
        return data;
    }
}
export class AddressDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.address = _data["address"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.pafId = _data["pafId"];
            this.street = _data["street"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
            this.deliveryArea = _data["deliveryArea"];
            this.depotCode = _data["depotCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddressDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["address"] = this.address;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["pafId"] = this.pafId;
        data["street"] = this.street;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        data["deliveryArea"] = this.deliveryArea;
        data["depotCode"] = this.depotCode;
        return data;
    }
}
export class CustomerCreditDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.amount = _data["amount"];
            this.customerCreditId = _data["customerCreditId"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerCreditDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["amount"] = this.amount;
        data["customerCreditId"] = this.customerCreditId;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined;
        return data;
    }
}
export class PaymentDueDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.amount = _data["amount"];
            this.deliveryId = _data["deliveryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDueDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["deliveryId"] = this.deliveryId;
        return data;
    }
}
export class VoucherDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.remainingAmount = _data["remainingAmount"];
            this.voucherCode = _data["voucherCode"];
            this.expiryDate = _data["expiryDate"] ? new Date(_data["expiryDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VoucherDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["remainingAmount"] = this.remainingAmount;
        data["voucherCode"] = this.voucherCode;
        data["expiryDate"] = this.expiryDate ? this.expiryDate.toISOString() : undefined;
        return data;
    }
}
export class CustomerProfileSubscriptionDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.productCollectionCode = _data["productCollectionCode"];
            this.productName = _data["productName"];
            this.iconUrl = _data["iconUrl"];
            this.iconSvgUrl = _data["iconSvgUrl"];
            this.isActive = _data["isActive"];
            this.deliverySlot = _data["deliverySlot"] ? DeliverySlotDto.fromJS(_data["deliverySlot"]) : undefined;
            this.hasFlexedDeliveryAddress = _data["hasFlexedDeliveryAddress"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerProfileSubscriptionDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["productCollectionCode"] = this.productCollectionCode;
        data["productName"] = this.productName;
        data["iconUrl"] = this.iconUrl;
        data["iconSvgUrl"] = this.iconSvgUrl;
        data["isActive"] = this.isActive;
        data["deliverySlot"] = this.deliverySlot ? this.deliverySlot.toJSON() : undefined;
        data["hasFlexedDeliveryAddress"] = this.hasFlexedDeliveryAddress;
        return data;
    }
}
export class DeliverySlotDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliverySlotId = _data["deliverySlotId"];
            this.actualDeliveryStartTime = _data["actualDeliveryStartTime"];
            this.actualDeliveryEndTime = _data["actualDeliveryEndTime"];
            this.deliveryDay = _data["deliveryDay"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeliverySlotDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliverySlotId"] = this.deliverySlotId;
        data["actualDeliveryStartTime"] = this.actualDeliveryStartTime;
        data["actualDeliveryEndTime"] = this.actualDeliveryEndTime;
        data["deliveryDay"] = this.deliveryDay;
        return data;
    }
}
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["Sunday"] = 0] = "Sunday";
    DayOfWeek[DayOfWeek["Monday"] = 1] = "Monday";
    DayOfWeek[DayOfWeek["Tuesday"] = 2] = "Tuesday";
    DayOfWeek[DayOfWeek["Wednesday"] = 3] = "Wednesday";
    DayOfWeek[DayOfWeek["Thursday"] = 4] = "Thursday";
    DayOfWeek[DayOfWeek["Friday"] = 5] = "Friday";
    DayOfWeek[DayOfWeek["Saturday"] = 6] = "Saturday";
})(DayOfWeek || (DayOfWeek = {}));
export class ProblemDetails {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {};
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        this.extensions[key] = _data["extensions"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    data["extensions"][key] = this.extensions[key];
            }
        }
        return data;
    }
}
export class UpdateRecipeCardPreferenceBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.optOutRecipeCards = _data["optOutRecipeCards"];
            this.subscriptionNumber = _data["subscriptionNumber"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRecipeCardPreferenceBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["optOutRecipeCards"] = this.optOutRecipeCards;
        data["subscriptionNumber"] = this.subscriptionNumber;
        return data;
    }
}
export class OrderWithRecipesAndExtras {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliveryId = _data["deliveryId"];
            this.orderKey = _data["orderKey"];
            this.deliveryDate = _data["deliveryDate"] ? DeliveryDateResponse.fromJS(_data["deliveryDate"]) : undefined;
            this.deliveryDateSource = _data["deliveryDateSource"];
            this.overrideDeliveryDate = _data["overrideDeliveryDate"] ? DeliveryDateResponse.fromJS(_data["overrideDeliveryDate"]) : undefined;
            this.originalDeliveryDate = _data["originalDeliveryDate"] ? DeliveryDateResponse.fromJS(_data["originalDeliveryDate"]) : undefined;
            this.deliveryAddress = _data["deliveryAddress"] ? AddressResponse.fromJS(_data["deliveryAddress"]) : undefined;
            this.isSkipped = _data["isSkipped"];
            this.isCreating = _data["isCreating"];
            this.deliveryStatus = _data["deliveryStatus"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["deliveryLines"])) {
                this.deliveryLines = [];
                for (let item of _data["deliveryLines"])
                    this.deliveryLines.push(DeliveryLineResponse.fromJS(item));
            }
            this.isDeliveryAddressSameAsDefault = _data["isDeliveryAddressSameAsDefault"];
            this.isVirtual = _data["isVirtual"];
            this.isOneOffOrder = _data["isOneOffOrder"];
            this.isDemandLocked = _data["isDemandLocked"];
            this.orderActions = _data["orderActions"] ? OrderActionsResponse.fromJS(_data["orderActions"]) : undefined;
            if (Array.isArray(_data["availableRecipes"])) {
                this.availableRecipes = [];
                for (let item of _data["availableRecipes"])
                    this.availableRecipes.push(RecipeResponse.fromJS(item));
            }
            if (Array.isArray(_data["defaultRecipeCategories"])) {
                this.defaultRecipeCategories = [];
                for (let item of _data["defaultRecipeCategories"])
                    this.defaultRecipeCategories.push(item);
            }
            this.pricing = _data["pricing"] ? PricingResponse.fromJS(_data["pricing"]) : undefined;
            this.skipReason = _data["skipReason"];
            this.deliveryOrderDate = _data["deliveryOrderDate"] ? new Date(_data["deliveryOrderDate"].toString()) : undefined;
            if (Array.isArray(_data["selectedExtras"])) {
                this.selectedExtras = [];
                for (let item of _data["selectedExtras"])
                    this.selectedExtras.push(DeliveryLineResponse.fromJS(item));
            }
            if (Array.isArray(_data["selectedRecipes"])) {
                this.selectedRecipes = [];
                for (let item of _data["selectedRecipes"])
                    this.selectedRecipes.push(RecipeResponse.fromJS(item));
            }
            this.productOptionId = _data["productOptionId"];
            this.availableFrequency = _data["availableFrequency"];
            this.hasAvailableBufferDates = _data["hasAvailableBufferDates"];
            this.publicHolidayName = _data["publicHolidayName"];
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [];
                for (let item of _data["notifications"])
                    this.notifications.push(NotificationResponse.fromJS(item));
            }
            this.isFirstDeliveryForSubscription = _data["isFirstDeliveryForSubscription"];
            this.isLastDeliveryForSubscription = _data["isLastDeliveryForSubscription"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderWithRecipesAndExtras();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["orderKey"] = this.orderKey;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toJSON() : undefined;
        data["deliveryDateSource"] = this.deliveryDateSource;
        data["overrideDeliveryDate"] = this.overrideDeliveryDate ? this.overrideDeliveryDate.toJSON() : undefined;
        data["originalDeliveryDate"] = this.originalDeliveryDate ? this.originalDeliveryDate.toJSON() : undefined;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : undefined;
        data["isSkipped"] = this.isSkipped;
        data["isCreating"] = this.isCreating;
        data["deliveryStatus"] = this.deliveryStatus;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.deliveryLines)) {
            data["deliveryLines"] = [];
            for (let item of this.deliveryLines)
                data["deliveryLines"].push(item.toJSON());
        }
        data["isDeliveryAddressSameAsDefault"] = this.isDeliveryAddressSameAsDefault;
        data["isVirtual"] = this.isVirtual;
        data["isOneOffOrder"] = this.isOneOffOrder;
        data["isDemandLocked"] = this.isDemandLocked;
        data["orderActions"] = this.orderActions ? this.orderActions.toJSON() : undefined;
        if (Array.isArray(this.availableRecipes)) {
            data["availableRecipes"] = [];
            for (let item of this.availableRecipes)
                data["availableRecipes"].push(item.toJSON());
        }
        if (Array.isArray(this.defaultRecipeCategories)) {
            data["defaultRecipeCategories"] = [];
            for (let item of this.defaultRecipeCategories)
                data["defaultRecipeCategories"].push(item);
        }
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["skipReason"] = this.skipReason;
        data["deliveryOrderDate"] = this.deliveryOrderDate ? this.deliveryOrderDate.toISOString() : undefined;
        if (Array.isArray(this.selectedExtras)) {
            data["selectedExtras"] = [];
            for (let item of this.selectedExtras)
                data["selectedExtras"].push(item.toJSON());
        }
        if (Array.isArray(this.selectedRecipes)) {
            data["selectedRecipes"] = [];
            for (let item of this.selectedRecipes)
                data["selectedRecipes"].push(item.toJSON());
        }
        data["productOptionId"] = this.productOptionId;
        data["availableFrequency"] = this.availableFrequency;
        data["hasAvailableBufferDates"] = this.hasAvailableBufferDates;
        data["publicHolidayName"] = this.publicHolidayName;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        data["isFirstDeliveryForSubscription"] = this.isFirstDeliveryForSubscription;
        data["isLastDeliveryForSubscription"] = this.isLastDeliveryForSubscription;
        return data;
    }
}
export class DeliveryDateResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliveryDateId = _data["deliveryDateId"];
            this.deliverySlotId = _data["deliverySlotId"];
            this.weekStarting = _data["weekStarting"] ? new Date(_data["weekStarting"].toString()) : undefined;
            this.actualDeliveryDate = _data["actualDeliveryDate"] ? new Date(_data["actualDeliveryDate"].toString()) : undefined;
            this.actualDeliveryStartTime = _data["actualDeliveryStartTime"];
            this.actualDeliveryEndTime = _data["actualDeliveryEndTime"];
            this.availableToDateTime = _data["availableToDateTime"] ? new Date(_data["availableToDateTime"].toString()) : undefined;
            this.isDisabled = _data["isDisabled"];
            this.marketingLabel = _data["marketingLabel"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDateId"] = this.deliveryDateId;
        data["deliverySlotId"] = this.deliverySlotId;
        data["weekStarting"] = this.weekStarting ? this.weekStarting.toISOString() : undefined;
        data["actualDeliveryDate"] = this.actualDeliveryDate ? this.actualDeliveryDate.toISOString() : undefined;
        data["actualDeliveryStartTime"] = this.actualDeliveryStartTime;
        data["actualDeliveryEndTime"] = this.actualDeliveryEndTime;
        data["availableToDateTime"] = this.availableToDateTime ? this.availableToDateTime.toISOString() : undefined;
        data["isDisabled"] = this.isDisabled;
        data["marketingLabel"] = this.marketingLabel;
        return data;
    }
}
export var DeliveryDateSource;
(function (DeliveryDateSource) {
    DeliveryDateSource[DeliveryDateSource["General"] = 0] = "General";
    DeliveryDateSource[DeliveryDateSource["SubscriptionOverride"] = 1] = "SubscriptionOverride";
    DeliveryDateSource[DeliveryDateSource["DeliverySlotOverride"] = 2] = "DeliverySlotOverride";
})(DeliveryDateSource || (DeliveryDateSource = {}));
export class AddressResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.addressId = _data["addressId"];
            this.street = _data["street"];
            this.suburb = _data["suburb"];
            this.city = _data["city"];
            this.postcode = _data["postcode"];
            this.deliveryInstructions = _data["deliveryInstructions"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddressResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["addressId"] = this.addressId;
        data["street"] = this.street;
        data["suburb"] = this.suburb;
        data["city"] = this.city;
        data["postcode"] = this.postcode;
        data["deliveryInstructions"] = this.deliveryInstructions;
        return data;
    }
}
export var DeliveryStatus;
(function (DeliveryStatus) {
    DeliveryStatus[DeliveryStatus["Ordered"] = 2] = "Ordered";
    DeliveryStatus[DeliveryStatus["Locked"] = 3] = "Locked";
    DeliveryStatus[DeliveryStatus["Delivered"] = 4] = "Delivered";
})(DeliveryStatus || (DeliveryStatus = {}));
export class DeliveryLineResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliveryLineType = _data["deliveryLineType"];
            this.sku = _data["sku"];
            this.lineDescription = _data["lineDescription"];
            this.simpleName = _data["simpleName"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.displayQuantity = _data["displayQuantity"];
            this.subTotal = _data["subTotal"];
            this.order = _data["order"];
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [];
                for (let item of _data["discounts"])
                    this.discounts.push(DeliveryDiscountLineResponse.fromJS(item));
            }
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [];
                for (let item of _data["recipes"])
                    this.recipes.push(RecipeResponse.fromJS(item));
            }
            this.requiredSelectionQuantity = _data["requiredSelectionQuantity"];
            this.recipeSelectionMode = _data["recipeSelectionMode"];
            this.maximumSelectionQuantity = _data["maximumSelectionQuantity"];
            this.baseSku = _data["baseSku"];
            this.isFlexed = _data["isFlexed"];
            this.imageUrl = _data["imageUrl"];
            this.isPromotional = _data["isPromotional"];
            this.isRecurring = _data["isRecurring"];
            this.extraSource = _data["extraSource"];
            this.extraFrequency = _data["extraFrequency"];
            if (Array.isArray(_data["addOnToRecipeNumbers"])) {
                this.addOnToRecipeNumbers = [];
                for (let item of _data["addOnToRecipeNumbers"])
                    this.addOnToRecipeNumbers.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryLineResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryLineType"] = this.deliveryLineType;
        data["sku"] = this.sku;
        data["lineDescription"] = this.lineDescription;
        data["simpleName"] = this.simpleName;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["displayQuantity"] = this.displayQuantity;
        data["subTotal"] = this.subTotal;
        data["order"] = this.order;
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item.toJSON());
        }
        data["requiredSelectionQuantity"] = this.requiredSelectionQuantity;
        data["recipeSelectionMode"] = this.recipeSelectionMode;
        data["maximumSelectionQuantity"] = this.maximumSelectionQuantity;
        data["baseSku"] = this.baseSku;
        data["isFlexed"] = this.isFlexed;
        data["imageUrl"] = this.imageUrl;
        data["isPromotional"] = this.isPromotional;
        data["isRecurring"] = this.isRecurring;
        data["extraSource"] = this.extraSource;
        data["extraFrequency"] = this.extraFrequency;
        if (Array.isArray(this.addOnToRecipeNumbers)) {
            data["addOnToRecipeNumbers"] = [];
            for (let item of this.addOnToRecipeNumbers)
                data["addOnToRecipeNumbers"].push(item);
        }
        return data;
    }
}
export class DeliveryDiscountLineResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.discount = _data["discount"];
            this.discountType = _data["discountType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDiscountLineResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["discountType"] = this.discountType;
        return data;
    }
}
export var DeliveryLineDiscountType;
(function (DeliveryLineDiscountType) {
    DeliveryLineDiscountType[DeliveryLineDiscountType["CustomerPerpetualDiscount"] = 1] = "CustomerPerpetualDiscount";
    DeliveryLineDiscountType[DeliveryLineDiscountType["PromoDiscount"] = 2] = "PromoDiscount";
    DeliveryLineDiscountType[DeliveryLineDiscountType["CustomerBalancePayment"] = 3] = "CustomerBalancePayment";
    DeliveryLineDiscountType[DeliveryLineDiscountType["ReferAFriendDiscount"] = 4] = "ReferAFriendDiscount";
    DeliveryLineDiscountType[DeliveryLineDiscountType["VoucherPayment"] = 5] = "VoucherPayment";
    DeliveryLineDiscountType[DeliveryLineDiscountType["SubscriptionOptIn"] = 6] = "SubscriptionOptIn";
    DeliveryLineDiscountType[DeliveryLineDiscountType["Migration"] = 7] = "Migration";
    DeliveryLineDiscountType[DeliveryLineDiscountType["CustomerOptIn"] = 8] = "CustomerOptIn";
})(DeliveryLineDiscountType || (DeliveryLineDiscountType = {}));
export class RecipeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.imageUrl = _data["imageUrl"];
            this.title = _data["title"];
            this.subtitle = _data["subtitle"];
            this.quantity = _data["quantity"];
            this.categoryCode = _data["categoryCode"];
            this.readyInTime = _data["readyInTime"];
            this.isDemandLocked = _data["isDemandLocked"];
            this.recipeNumber = _data["recipeNumber"];
            this.recipePartition = _data["recipePartition"];
            this.recipeVersion = _data["recipeVersion"];
            this.badge = _data["badge"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.sortOrder = _data["sortOrder"];
            this.surcharge = _data["surcharge"] ? RecipePricingResponse.fromJS(_data["surcharge"]) : undefined;
            this.maximumQuantity = _data["maximumQuantity"];
            this.servingSize = _data["servingSize"];
            this.consumption = _data["consumption"];
            if (Array.isArray(_data["validRecipeAddOns"])) {
                this.validRecipeAddOns = [];
                for (let item of _data["validRecipeAddOns"])
                    this.validRecipeAddOns.push(ValidRecipeAddOnResponse.fromJS(item));
            }
            if (Array.isArray(_data["recipeAddOns"])) {
                this.recipeAddOns = [];
                for (let item of _data["recipeAddOns"])
                    this.recipeAddOns.push(RecipeAddOnResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["imageUrl"] = this.imageUrl;
        data["title"] = this.title;
        data["subtitle"] = this.subtitle;
        data["quantity"] = this.quantity;
        data["categoryCode"] = this.categoryCode;
        data["readyInTime"] = this.readyInTime;
        data["isDemandLocked"] = this.isDemandLocked;
        data["recipeNumber"] = this.recipeNumber;
        data["recipePartition"] = this.recipePartition;
        data["recipeVersion"] = this.recipeVersion;
        data["badge"] = this.badge;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["sortOrder"] = this.sortOrder;
        data["surcharge"] = this.surcharge ? this.surcharge.toJSON() : undefined;
        data["maximumQuantity"] = this.maximumQuantity;
        data["servingSize"] = this.servingSize;
        data["consumption"] = this.consumption;
        if (Array.isArray(this.validRecipeAddOns)) {
            data["validRecipeAddOns"] = [];
            for (let item of this.validRecipeAddOns)
                data["validRecipeAddOns"].push(item.toJSON());
        }
        if (Array.isArray(this.recipeAddOns)) {
            data["recipeAddOns"] = [];
            for (let item of this.recipeAddOns)
                data["recipeAddOns"].push(item.toJSON());
        }
        return data;
    }
}
export class RecipePricingResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.listPrice = new ItemDisplayPriceResponse();
            this.salePrice = new SaleDisplayPriceResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.listPrice = _data["listPrice"] ? ItemDisplayPriceResponse.fromJS(_data["listPrice"]) : new ItemDisplayPriceResponse();
            this.salePrice = _data["salePrice"] ? SaleDisplayPriceResponse.fromJS(_data["salePrice"]) : new SaleDisplayPriceResponse();
            this.hasDiscount = _data["hasDiscount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipePricingResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice ? this.listPrice.toJSON() : undefined;
        data["salePrice"] = this.salePrice ? this.salePrice.toJSON() : undefined;
        data["hasDiscount"] = this.hasDiscount;
        return data;
    }
}
export class ItemDisplayPriceResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemPrice = _data["itemPrice"];
            this.deliveryPrice = _data["deliveryPrice"];
            this.totalPrice = _data["totalPrice"];
            this.serves = _data["serves"];
            this.itemPricePerServe = _data["itemPricePerServe"];
            this.totalPricePerServe = _data["totalPricePerServe"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDisplayPriceResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemPrice"] = this.itemPrice;
        data["deliveryPrice"] = this.deliveryPrice;
        data["totalPrice"] = this.totalPrice;
        data["serves"] = this.serves;
        data["itemPricePerServe"] = this.itemPricePerServe;
        data["totalPricePerServe"] = this.totalPricePerServe;
        return data;
    }
}
export class SaleDisplayPriceResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemPrice = _data["itemPrice"];
            this.deliveryPrice = _data["deliveryPrice"];
            this.totalPrice = _data["totalPrice"];
            this.serves = _data["serves"];
            this.itemPricePerServe = _data["itemPricePerServe"];
            this.totalPricePerServe = _data["totalPricePerServe"];
            this.hasDiscount = _data["hasDiscount"];
            this.discountSource = _data["discountSource"];
            this.promoCodeApplied = _data["promoCodeApplied"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleDisplayPriceResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemPrice"] = this.itemPrice;
        data["deliveryPrice"] = this.deliveryPrice;
        data["totalPrice"] = this.totalPrice;
        data["serves"] = this.serves;
        data["itemPricePerServe"] = this.itemPricePerServe;
        data["totalPricePerServe"] = this.totalPricePerServe;
        data["hasDiscount"] = this.hasDiscount;
        data["discountSource"] = this.discountSource;
        data["promoCodeApplied"] = this.promoCodeApplied;
        return data;
    }
}
export var DiscountSource;
(function (DiscountSource) {
    DiscountSource[DiscountSource["None"] = 0] = "None";
    DiscountSource[DiscountSource["Other"] = 1] = "Other";
    DiscountSource[DiscountSource["CustomerPerpetualDiscount"] = 2] = "CustomerPerpetualDiscount";
    DiscountSource[DiscountSource["PromoCode"] = 3] = "PromoCode";
})(DiscountSource || (DiscountSource = {}));
export class ValidRecipeAddOnResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.pricing = _data["pricing"] ? ProductPricingResponse.fromJS(_data["pricing"]) : undefined;
            this.displayName = _data["displayName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidRecipeAddOnResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["displayName"] = this.displayName;
        return data;
    }
}
export class ProductPricingResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.listPrice = new ItemDisplayPriceResponse();
            this.salePrice = new SaleDisplayPriceResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.listPrice = _data["listPrice"] ? ItemDisplayPriceResponse.fromJS(_data["listPrice"]) : new ItemDisplayPriceResponse();
            this.salePrice = _data["salePrice"] ? SaleDisplayPriceResponse.fromJS(_data["salePrice"]) : new SaleDisplayPriceResponse();
            this.hasDiscount = _data["hasDiscount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductPricingResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice ? this.listPrice.toJSON() : undefined;
        data["salePrice"] = this.salePrice ? this.salePrice.toJSON() : undefined;
        data["hasDiscount"] = this.hasDiscount;
        return data;
    }
}
export class RecipeAddOnResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.displayName = _data["displayName"];
            this.pricing = _data["pricing"] ? ProductPricingResponse.fromJS(_data["pricing"]) : undefined;
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeAddOnResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["displayName"] = this.displayName;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["quantity"] = this.quantity;
        return data;
    }
}
export var RecipeSelectionMode;
(function (RecipeSelectionMode) {
    RecipeSelectionMode[RecipeSelectionMode["None"] = 0] = "None";
    RecipeSelectionMode[RecipeSelectionMode["Single"] = 1] = "Single";
    RecipeSelectionMode[RecipeSelectionMode["Multiple"] = 2] = "Multiple";
})(RecipeSelectionMode || (RecipeSelectionMode = {}));
export var ExtraLineSource;
(function (ExtraLineSource) {
    ExtraLineSource[ExtraLineSource["Other"] = 0] = "Other";
    ExtraLineSource[ExtraLineSource["SubscriptionOptIn"] = 1] = "SubscriptionOptIn";
    ExtraLineSource[ExtraLineSource["SubscriptionAddOn"] = 2] = "SubscriptionAddOn";
    ExtraLineSource[ExtraLineSource["CustomerOptIn"] = 3] = "CustomerOptIn";
    ExtraLineSource[ExtraLineSource["SubscriptionPromo"] = 4] = "SubscriptionPromo";
})(ExtraLineSource || (ExtraLineSource = {}));
export var Frequency;
(function (Frequency) {
    Frequency[Frequency["Weekly"] = 1] = "Weekly";
    Frequency[Frequency["Fortnightly"] = 2] = "Fortnightly";
    Frequency[Frequency["OneOff"] = 3] = "OneOff";
    Frequency[Frequency["FourWeekly"] = 4] = "FourWeekly";
})(Frequency || (Frequency = {}));
export class OrderActionsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.canSkip = _data["canSkip"] ? OrderActionStateResponse.fromJS(_data["canSkip"]) : undefined;
            this.canUnskip = _data["canUnskip"] ? OrderActionStateResponse.fromJS(_data["canUnskip"]) : undefined;
            this.canChangeMeals = _data["canChangeMeals"] ? OrderActionStateResponse.fromJS(_data["canChangeMeals"]) : undefined;
            this.canAddExtras = _data["canAddExtras"] ? OrderActionStateResponse.fromJS(_data["canAddExtras"]) : undefined;
            this.canChangeBag = _data["canChangeBag"] ? OrderActionStateResponse.fromJS(_data["canChangeBag"]) : undefined;
            this.canChangeDeliveryShipping = _data["canChangeDeliveryShipping"] ? OrderActionStateResponse.fromJS(_data["canChangeDeliveryShipping"]) : undefined;
            this.canRateRecipes = _data["canRateRecipes"] ? OrderActionStateResponse.fromJS(_data["canRateRecipes"]) : undefined;
            this.canRestartSubscription = _data["canRestartSubscription"] ? OrderActionStateResponse.fromJS(_data["canRestartSubscription"]) : undefined;
            this.canApplyNewPromo = _data["canApplyNewPromo"] ? OrderActionStateResponse.fromJS(_data["canApplyNewPromo"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderActionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["canSkip"] = this.canSkip ? this.canSkip.toJSON() : undefined;
        data["canUnskip"] = this.canUnskip ? this.canUnskip.toJSON() : undefined;
        data["canChangeMeals"] = this.canChangeMeals ? this.canChangeMeals.toJSON() : undefined;
        data["canAddExtras"] = this.canAddExtras ? this.canAddExtras.toJSON() : undefined;
        data["canChangeBag"] = this.canChangeBag ? this.canChangeBag.toJSON() : undefined;
        data["canChangeDeliveryShipping"] = this.canChangeDeliveryShipping ? this.canChangeDeliveryShipping.toJSON() : undefined;
        data["canRateRecipes"] = this.canRateRecipes ? this.canRateRecipes.toJSON() : undefined;
        data["canRestartSubscription"] = this.canRestartSubscription ? this.canRestartSubscription.toJSON() : undefined;
        data["canApplyNewPromo"] = this.canApplyNewPromo ? this.canApplyNewPromo.toJSON() : undefined;
        return data;
    }
}
export class OrderActionStateResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isValid = _data["isValid"];
            this.effectiveUntilActual = _data["effectiveUntilActual"] ? new Date(_data["effectiveUntilActual"].toString()) : undefined;
            this.effectiveUntilDate = _data["effectiveUntilDate"] ? new Date(_data["effectiveUntilDate"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderActionStateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        data["effectiveUntilActual"] = this.effectiveUntilActual ? this.effectiveUntilActual.toISOString() : undefined;
        data["effectiveUntilDate"] = this.effectiveUntilDate ? this.effectiveUntilDate.toISOString() : undefined;
        return data;
    }
}
export class PricingResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.shipping = _data["shipping"];
            this.subTotal = _data["subTotal"];
            this.overallTotal = _data["overallTotal"];
            this.appliedDiscount = _data["appliedDiscount"] ? AppliedDiscountResponse.fromJS(_data["appliedDiscount"]) : undefined;
            if (Array.isArray(_data["discounts"])) {
                this.discounts = [];
                for (let item of _data["discounts"])
                    this.discounts.push(DiscountRollupResponse.fromJS(item));
            }
            this.summary = _data["summary"] ? PricingLineSummaryDto.fromJS(_data["summary"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PricingResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["shipping"] = this.shipping;
        data["subTotal"] = this.subTotal;
        data["overallTotal"] = this.overallTotal;
        data["appliedDiscount"] = this.appliedDiscount ? this.appliedDiscount.toJSON() : undefined;
        if (Array.isArray(this.discounts)) {
            data["discounts"] = [];
            for (let item of this.discounts)
                data["discounts"].push(item.toJSON());
        }
        data["summary"] = this.summary ? this.summary.toJSON() : undefined;
        return data;
    }
}
export class AppliedDiscountResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.discountSource = _data["discountSource"];
            this.promoGroupCode = _data["promoGroupCode"];
            this.promoCode = _data["promoCode"];
            this.hasDiscountApplied = _data["hasDiscountApplied"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AppliedDiscountResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["discountSource"] = this.discountSource;
        data["promoGroupCode"] = this.promoGroupCode;
        data["promoCode"] = this.promoCode;
        data["hasDiscountApplied"] = this.hasDiscountApplied;
        return data;
    }
}
export class DiscountRollupResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.amount = _data["amount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DiscountRollupResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["amount"] = this.amount;
        return data;
    }
}
export class PricingLineSummaryDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.primaryLine = _data["primaryLine"] ? PricingLineDto.fromJS(_data["primaryLine"]) : undefined;
            this.upsellLine = _data["upsellLine"] ? PricingLineDto.fromJS(_data["upsellLine"]) : undefined;
            this.flexedLine = _data["flexedLine"] ? PricingLineDto.fromJS(_data["flexedLine"]) : undefined;
            this.extrasLine = _data["extrasLine"] ? PricingLineDto.fromJS(_data["extrasLine"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PricingLineSummaryDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["primaryLine"] = this.primaryLine ? this.primaryLine.toJSON() : undefined;
        data["upsellLine"] = this.upsellLine ? this.upsellLine.toJSON() : undefined;
        data["flexedLine"] = this.flexedLine ? this.flexedLine.toJSON() : undefined;
        data["extrasLine"] = this.extrasLine ? this.extrasLine.toJSON() : undefined;
        return data;
    }
}
export class PricingLineDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.price = _data["price"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PricingLineDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["price"] = this.price;
        return data;
    }
}
export var SkipReason;
(function (SkipReason) {
    SkipReason[SkipReason["None"] = 0] = "None";
    SkipReason[SkipReason["ManualUnskip"] = 1] = "ManualUnskip";
    SkipReason[SkipReason["ManualSkip"] = 2] = "ManualSkip";
    SkipReason[SkipReason["OffWeekSkip"] = 3] = "OffWeekSkip";
    SkipReason[SkipReason["HolidaySkip"] = 4] = "HolidaySkip";
    SkipReason[SkipReason["ExistingDeliveryForOneOff"] = 5] = "ExistingDeliveryForOneOff";
    SkipReason[SkipReason["CustomerWasMigrated"] = 6] = "CustomerWasMigrated";
    SkipReason[SkipReason["PrimaryProductHasEnded"] = 7] = "PrimaryProductHasEnded";
})(SkipReason || (SkipReason = {}));
export var AvailableFrequency;
(function (AvailableFrequency) {
    AvailableFrequency[AvailableFrequency["Weekly"] = 1] = "Weekly";
    AvailableFrequency[AvailableFrequency["Fortnightly"] = 2] = "Fortnightly";
    AvailableFrequency[AvailableFrequency["OneOff"] = 4] = "OneOff";
    AvailableFrequency[AvailableFrequency["FourWeekly"] = 8] = "FourWeekly";
})(AvailableFrequency || (AvailableFrequency = {}));
export class NotificationResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.iconUrl = _data["iconUrl"];
            this.title = _data["title"];
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NotificationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["iconUrl"] = this.iconUrl;
        data["title"] = this.title;
        data["message"] = this.message;
        return data;
    }
}
export class SingleOrderWithRecipesAndExtras {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orderWithRecipesAndExtras = _data["orderWithRecipesAndExtras"] ? OrderWithRecipesAndExtras.fromJS(_data["orderWithRecipesAndExtras"]) : undefined;
            this.promo = _data["promo"] ? BenefitDto.fromJS(_data["promo"]) : undefined;
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SingleOrderWithRecipesAndExtras();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["orderWithRecipesAndExtras"] = this.orderWithRecipesAndExtras ? this.orderWithRecipesAndExtras.toJSON() : undefined;
        data["promo"] = this.promo ? this.promo.toJSON() : undefined;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}
export class BenefitDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.benefitType = _data["benefitType"];
            this.amount = _data["amount"];
            this.message = _data["message"];
            this.product = _data["product"] ? ProductSummary.fromJS(_data["product"]) : undefined;
            this.consumableFrom = _data["consumableFrom"] ? new Date(_data["consumableFrom"].toString()) : undefined;
            this.consumableTo = _data["consumableTo"] ? new Date(_data["consumableTo"].toString()) : undefined;
            if (Array.isArray(_data["addProductBenefits"])) {
                this.addProductBenefits = [];
                for (let item of _data["addProductBenefits"])
                    this.addProductBenefits.push(AddProductBenefitDto.fromJS(item));
            }
            if (Array.isArray(_data["priceBenefits"])) {
                this.priceBenefits = [];
                for (let item of _data["priceBenefits"])
                    this.priceBenefits.push(PriceBenefitDto.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BenefitDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["benefitType"] = this.benefitType;
        data["amount"] = this.amount;
        data["message"] = this.message;
        data["product"] = this.product ? this.product.toJSON() : undefined;
        data["consumableFrom"] = this.consumableFrom ? this.consumableFrom.toISOString() : undefined;
        data["consumableTo"] = this.consumableTo ? this.consumableTo.toISOString() : undefined;
        if (Array.isArray(this.addProductBenefits)) {
            data["addProductBenefits"] = [];
            for (let item of this.addProductBenefits)
                data["addProductBenefits"].push(item.toJSON());
        }
        if (Array.isArray(this.priceBenefits)) {
            data["priceBenefits"] = [];
            for (let item of this.priceBenefits)
                data["priceBenefits"].push(item.toJSON());
        }
        return data;
    }
}
export var BenefitType;
(function (BenefitType) {
    BenefitType[BenefitType["ValueOff"] = 0] = "ValueOff";
    BenefitType[BenefitType["PercentageOff"] = 1] = "PercentageOff";
    BenefitType[BenefitType["FixedPrice"] = 2] = "FixedPrice";
})(BenefitType || (BenefitType = {}));
export class ProductSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.productOptionName = _data["productOptionName"];
            this.productName = _data["productName"];
            this.sku = _data["sku"];
            this.itemNumber = _data["itemNumber"];
            this.numberOfPlates = _data["numberOfPlates"];
            this.totalPrice = _data["totalPrice"];
            this.deliveryPrice = _data["deliveryPrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["productOptionName"] = this.productOptionName;
        data["productName"] = this.productName;
        data["sku"] = this.sku;
        data["itemNumber"] = this.itemNumber;
        data["numberOfPlates"] = this.numberOfPlates;
        data["totalPrice"] = this.totalPrice;
        data["deliveryPrice"] = this.deliveryPrice;
        return data;
    }
}
export class AddProductBenefitDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.product = _data["product"] ? ProductSummary.fromJS(_data["product"]) : undefined;
            this.overridePrice = _data["overridePrice"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AddProductBenefitDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["product"] = this.product ? this.product.toJSON() : undefined;
        data["overridePrice"] = this.overridePrice;
        return data;
    }
}
export class PriceBenefitDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.benefitType = _data["benefitType"];
            this.benefitValue = _data["benefitValue"];
            this.selector = _data["selector"];
            this.productSelectorType = _data["productSelectorType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PriceBenefitDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["benefitType"] = this.benefitType;
        data["benefitValue"] = this.benefitValue;
        data["selector"] = this.selector;
        data["productSelectorType"] = this.productSelectorType;
        return data;
    }
}
export var ProductSelectorType;
(function (ProductSelectorType) {
    ProductSelectorType[ProductSelectorType["All"] = 0] = "All";
    ProductSelectorType[ProductSelectorType["Sku"] = 1] = "Sku";
    ProductSelectorType[ProductSelectorType["Collection"] = 2] = "Collection";
    ProductSelectorType[ProductSelectorType["PrimaryCollection"] = 3] = "PrimaryCollection";
    ProductSelectorType[ProductSelectorType["KitchenCollection"] = 4] = "KitchenCollection";
    ProductSelectorType[ProductSelectorType["GourmetMeal"] = 5] = "GourmetMeal";
})(ProductSelectorType || (ProductSelectorType = {}));
export class AccountProductSummary {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.imageUrl = _data["imageUrl"];
            this.defaultFrequency = _data["defaultFrequency"];
            if (Array.isArray(_data["availableFrequencies"])) {
                this.availableFrequencies = [];
                for (let item of _data["availableFrequencies"])
                    this.availableFrequencies.push(item);
            }
            this.nights = _data["nights"];
            this.people = _data["people"];
            this.totalPrice = _data["totalPrice"];
            this.pricePerPlate = _data["pricePerPlate"];
            this.isDemandLocked = _data["isDemandLocked"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountProductSummary();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["imageUrl"] = this.imageUrl;
        data["defaultFrequency"] = this.defaultFrequency;
        if (Array.isArray(this.availableFrequencies)) {
            data["availableFrequencies"] = [];
            for (let item of this.availableFrequencies)
                data["availableFrequencies"].push(item);
        }
        data["nights"] = this.nights;
        data["people"] = this.people;
        data["totalPrice"] = this.totalPrice;
        data["pricePerPlate"] = this.pricePerPlate;
        data["isDemandLocked"] = this.isDemandLocked;
        return data;
    }
}
export class ProductAndRecipeDetailsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["badges"])) {
                this.badges = [];
                for (let item of _data["badges"])
                    this.badges.push(item);
            }
            this.numberOfPeopleToFeed = _data["numberOfPeopleToFeed"];
            this.imageUrl = _data["imageUrl"];
            this.additionalInformationUrl = _data["additionalInformationUrl"];
            this.retailPrice = _data["retailPrice"];
            this.canRateRecipe = _data["canRateRecipe"];
            this.defaultFrequency = _data["defaultFrequency"];
            if (Array.isArray(_data["availableFrequencies"])) {
                this.availableFrequencies = [];
                for (let item of _data["availableFrequencies"])
                    this.availableFrequencies.push(item);
            }
            this.isDemandLocked = _data["isDemandLocked"];
            this.pricing = _data["pricing"] ? ProductPricingResponse.fromJS(_data["pricing"]) : undefined;
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [];
                for (let item of _data["recipes"])
                    this.recipes.push(RecipeResponse2.fromJS(item));
            }
            this.recipeDetails = _data["recipeDetails"] ? RecipeResponse2.fromJS(_data["recipeDetails"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductAndRecipeDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.badges)) {
            data["badges"] = [];
            for (let item of this.badges)
                data["badges"].push(item);
        }
        data["numberOfPeopleToFeed"] = this.numberOfPeopleToFeed;
        data["imageUrl"] = this.imageUrl;
        data["additionalInformationUrl"] = this.additionalInformationUrl;
        data["retailPrice"] = this.retailPrice;
        data["canRateRecipe"] = this.canRateRecipe;
        data["defaultFrequency"] = this.defaultFrequency;
        if (Array.isArray(this.availableFrequencies)) {
            data["availableFrequencies"] = [];
            for (let item of this.availableFrequencies)
                data["availableFrequencies"].push(item);
        }
        data["isDemandLocked"] = this.isDemandLocked;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item.toJSON());
        }
        data["recipeDetails"] = this.recipeDetails ? this.recipeDetails.toJSON() : undefined;
        return data;
    }
}
export class RecipeResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.recipeNumber = _data["recipeNumber"];
            this.recipeVersion = _data["recipeVersion"];
            this.recipePartition = _data["recipePartition"];
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [];
                for (let item of _data["allergens"])
                    this.allergens.push(item);
            }
            if (Array.isArray(_data["allergensContains"])) {
                this.allergensContains = [];
                for (let item of _data["allergensContains"])
                    this.allergensContains.push(item);
            }
            if (Array.isArray(_data["allergensMayContain"])) {
                this.allergensMayContain = [];
                for (let item of _data["allergensMayContain"])
                    this.allergensMayContain.push(item);
            }
            this.composition = _data["composition"];
            if (Array.isArray(_data["ingredientGroups"])) {
                this.ingredientGroups = [];
                for (let item of _data["ingredientGroups"])
                    this.ingredientGroups.push(IngredientGroupResponse.fromJS(item));
            }
            this.numberOfServes = _data["numberOfServes"];
            this.readyInTime = _data["readyInTime"];
            this.badge = _data["badge"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.type = _data["type"];
            this.categoryCode = _data["categoryCode"];
            this.imageUrl = _data["imageUrl"];
            this.brand = _data["brand"];
            this.subtitle = _data["subtitle"];
            this.title = _data["title"];
            this.recipeDocumentId = _data["recipeDocumentId"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [];
                for (let item of _data["steps"])
                    this.steps.push(StepResponse.fromJS(item));
            }
            if (Array.isArray(_data["nutritionalInformation"])) {
                this.nutritionalInformation = [];
                for (let item of _data["nutritionalInformation"])
                    this.nutritionalInformation.push(NutritionResponse.fromJS(item));
            }
            this.surcharge = _data["surcharge"] ? RecipePricingResponse2.fromJS(_data["surcharge"]) : undefined;
            this.recipeCardStyleName = _data["recipeCardStyleName"];
            this.maximumQuantity = _data["maximumQuantity"];
            this.consumption = _data["consumption"];
            this.recipeId = _data["recipeId"];
            this.version = _data["version"];
            this.partitionKey = _data["partitionKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["recipeNumber"] = this.recipeNumber;
        data["recipeVersion"] = this.recipeVersion;
        data["recipePartition"] = this.recipePartition;
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (let item of this.allergens)
                data["allergens"].push(item);
        }
        if (Array.isArray(this.allergensContains)) {
            data["allergensContains"] = [];
            for (let item of this.allergensContains)
                data["allergensContains"].push(item);
        }
        if (Array.isArray(this.allergensMayContain)) {
            data["allergensMayContain"] = [];
            for (let item of this.allergensMayContain)
                data["allergensMayContain"].push(item);
        }
        data["composition"] = this.composition;
        if (Array.isArray(this.ingredientGroups)) {
            data["ingredientGroups"] = [];
            for (let item of this.ingredientGroups)
                data["ingredientGroups"].push(item.toJSON());
        }
        data["numberOfServes"] = this.numberOfServes;
        data["readyInTime"] = this.readyInTime;
        data["badge"] = this.badge;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["type"] = this.type;
        data["categoryCode"] = this.categoryCode;
        data["imageUrl"] = this.imageUrl;
        data["brand"] = this.brand;
        data["subtitle"] = this.subtitle;
        data["title"] = this.title;
        data["recipeDocumentId"] = this.recipeDocumentId;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.nutritionalInformation)) {
            data["nutritionalInformation"] = [];
            for (let item of this.nutritionalInformation)
                data["nutritionalInformation"].push(item.toJSON());
        }
        data["surcharge"] = this.surcharge ? this.surcharge.toJSON() : undefined;
        data["recipeCardStyleName"] = this.recipeCardStyleName;
        data["maximumQuantity"] = this.maximumQuantity;
        data["consumption"] = this.consumption;
        data["recipeId"] = this.recipeId;
        data["version"] = this.version;
        data["partitionKey"] = this.partitionKey;
        return data;
    }
}
export class IngredientGroupResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [];
                for (let item of _data["ingredients"])
                    this.ingredients.push(IngredientResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientGroupResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        return data;
    }
}
export class IngredientResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ingredientType = _data["ingredientType"];
            this.description = _data["description"];
            this.allergensContains = _data["allergensContains"];
            this.allergensMayContain = _data["allergensMayContain"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ingredientType"] = this.ingredientType;
        data["description"] = this.description;
        data["allergensContains"] = this.allergensContains;
        data["allergensMayContain"] = this.allergensMayContain;
        return data;
    }
}
export var IngredientType;
(function (IngredientType) {
    IngredientType[IngredientType["Other"] = 0] = "Other";
    IngredientType[IngredientType["Staple"] = 1] = "Staple";
    IngredientType[IngredientType["Shared"] = 2] = "Shared";
})(IngredientType || (IngredientType = {}));
export class StepResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.number = _data["number"];
            this.heading = _data["heading"];
            this.method = _data["method"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StepResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["heading"] = this.heading;
        data["method"] = this.method;
        return data;
    }
}
export class NutritionResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}
export class RecipePricingResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.listPrice = _data["listPrice"] ? ItemDisplayPriceResponse.fromJS(_data["listPrice"]) : undefined;
            this.salePrice = _data["salePrice"] ? SaleDisplayPriceResponse.fromJS(_data["salePrice"]) : undefined;
            this.hasDiscount = _data["hasDiscount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipePricingResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice ? this.listPrice.toJSON() : undefined;
        data["salePrice"] = this.salePrice ? this.salePrice.toJSON() : undefined;
        data["hasDiscount"] = this.hasDiscount;
        return data;
    }
}
export class ExtraDetailResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.numberOfServes = _data["numberOfServes"];
            this.imageUrl = _data["imageUrl"];
            this.description = _data["description"];
            this.frequency = _data["frequency"];
            this.price = _data["price"];
            this.isDemandLocked = _data["isDemandLocked"];
            this.pricing = _data["pricing"] ? ProductPricingResponse.fromJS(_data["pricing"]) : undefined;
            if (Array.isArray(_data["badges"])) {
                this.badges = [];
                for (let item of _data["badges"])
                    this.badges.push(item);
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.recipeDetail = _data["recipeDetail"] ? PricedRecipeResponse.fromJS(_data["recipeDetail"]) : undefined;
            if (Array.isArray(_data["recipeCollection"])) {
                this.recipeCollection = [];
                for (let item of _data["recipeCollection"])
                    this.recipeCollection.push(RecipeCollectionResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraDetailResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["numberOfServes"] = this.numberOfServes;
        data["imageUrl"] = this.imageUrl;
        data["description"] = this.description;
        data["frequency"] = this.frequency;
        data["price"] = this.price;
        data["isDemandLocked"] = this.isDemandLocked;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        if (Array.isArray(this.badges)) {
            data["badges"] = [];
            for (let item of this.badges)
                data["badges"].push(item);
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["recipeDetail"] = this.recipeDetail ? this.recipeDetail.toJSON() : undefined;
        if (Array.isArray(this.recipeCollection)) {
            data["recipeCollection"] = [];
            for (let item of this.recipeCollection)
                data["recipeCollection"].push(item.toJSON());
        }
        return data;
    }
}
export class PricedRecipeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.surcharge = _data["surcharge"] ? RecipePricingResponse2.fromJS(_data["surcharge"]) : undefined;
            if (Array.isArray(_data["ingredientGroups"])) {
                this.ingredientGroups = [];
                for (let item of _data["ingredientGroups"])
                    this.ingredientGroups.push(IngredientGroupResponse.fromJS(item));
            }
            this.recipeNumber = _data["recipeNumber"];
            this.recipeVersion = _data["recipeVersion"];
            this.recipePartition = _data["recipePartition"];
            if (Array.isArray(_data["allergens"])) {
                this.allergens = [];
                for (let item of _data["allergens"])
                    this.allergens.push(item);
            }
            if (Array.isArray(_data["allergensContains"])) {
                this.allergensContains = [];
                for (let item of _data["allergensContains"])
                    this.allergensContains.push(item);
            }
            if (Array.isArray(_data["allergensMayContain"])) {
                this.allergensMayContain = [];
                for (let item of _data["allergensMayContain"])
                    this.allergensMayContain.push(item);
            }
            this.composition = _data["composition"];
            this.numberOfServes = _data["numberOfServes"];
            this.readyInTime = _data["readyInTime"];
            this.badge = _data["badge"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(item);
            }
            this.description = _data["description"];
            this.sortOrder = _data["sortOrder"];
            this.type = _data["type"];
            this.categoryCode = _data["categoryCode"];
            this.imageUrl = _data["imageUrl"];
            this.brand = _data["brand"];
            this.subtitle = _data["subtitle"];
            this.title = _data["title"];
            this.recipeDocumentId = _data["recipeDocumentId"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [];
                for (let item of _data["steps"])
                    this.steps.push(StepResponse2.fromJS(item));
            }
            if (Array.isArray(_data["nutritionalInformation"])) {
                this.nutritionalInformation = [];
                for (let item of _data["nutritionalInformation"])
                    this.nutritionalInformation.push(NutritionResponse2.fromJS(item));
            }
            this.isFavourite = _data["isFavourite"];
            this.recipeCardStyleName = _data["recipeCardStyleName"];
            this.maximumQuantity = _data["maximumQuantity"];
            this.consumption = _data["consumption"];
            this.recipeId = _data["recipeId"];
            this.version = _data["version"];
            this.partitionKey = _data["partitionKey"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PricedRecipeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["surcharge"] = this.surcharge ? this.surcharge.toJSON() : undefined;
        if (Array.isArray(this.ingredientGroups)) {
            data["ingredientGroups"] = [];
            for (let item of this.ingredientGroups)
                data["ingredientGroups"].push(item.toJSON());
        }
        data["recipeNumber"] = this.recipeNumber;
        data["recipeVersion"] = this.recipeVersion;
        data["recipePartition"] = this.recipePartition;
        if (Array.isArray(this.allergens)) {
            data["allergens"] = [];
            for (let item of this.allergens)
                data["allergens"].push(item);
        }
        if (Array.isArray(this.allergensContains)) {
            data["allergensContains"] = [];
            for (let item of this.allergensContains)
                data["allergensContains"].push(item);
        }
        if (Array.isArray(this.allergensMayContain)) {
            data["allergensMayContain"] = [];
            for (let item of this.allergensMayContain)
                data["allergensMayContain"].push(item);
        }
        data["composition"] = this.composition;
        data["numberOfServes"] = this.numberOfServes;
        data["readyInTime"] = this.readyInTime;
        data["badge"] = this.badge;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["description"] = this.description;
        data["sortOrder"] = this.sortOrder;
        data["type"] = this.type;
        data["categoryCode"] = this.categoryCode;
        data["imageUrl"] = this.imageUrl;
        data["brand"] = this.brand;
        data["subtitle"] = this.subtitle;
        data["title"] = this.title;
        data["recipeDocumentId"] = this.recipeDocumentId;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            for (let item of this.steps)
                data["steps"].push(item.toJSON());
        }
        if (Array.isArray(this.nutritionalInformation)) {
            data["nutritionalInformation"] = [];
            for (let item of this.nutritionalInformation)
                data["nutritionalInformation"].push(item.toJSON());
        }
        data["isFavourite"] = this.isFavourite;
        data["recipeCardStyleName"] = this.recipeCardStyleName;
        data["maximumQuantity"] = this.maximumQuantity;
        data["consumption"] = this.consumption;
        data["recipeId"] = this.recipeId;
        data["version"] = this.version;
        data["partitionKey"] = this.partitionKey;
        return data;
    }
}
export class RecipePricingDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.listPrice = _data["listPrice"] ? ItemDisplayPriceDto.fromJS(_data["listPrice"]) : undefined;
            this.salePrice = _data["salePrice"] ? SaleDisplayPriceDto.fromJS(_data["salePrice"]) : undefined;
            this.hasDiscount = _data["hasDiscount"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipePricingDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["listPrice"] = this.listPrice ? this.listPrice.toJSON() : undefined;
        data["salePrice"] = this.salePrice ? this.salePrice.toJSON() : undefined;
        data["hasDiscount"] = this.hasDiscount;
        return data;
    }
}
export class ItemDisplayPriceDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemPrice = _data["itemPrice"];
            this.deliveryPrice = _data["deliveryPrice"];
            this.totalPrice = _data["totalPrice"];
            this.serves = _data["serves"];
            this.itemPricePerServe = _data["itemPricePerServe"];
            this.totalPricePerServe = _data["totalPricePerServe"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ItemDisplayPriceDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemPrice"] = this.itemPrice;
        data["deliveryPrice"] = this.deliveryPrice;
        data["totalPrice"] = this.totalPrice;
        data["serves"] = this.serves;
        data["itemPricePerServe"] = this.itemPricePerServe;
        data["totalPricePerServe"] = this.totalPricePerServe;
        return data;
    }
}
export class SaleDisplayPriceDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemPrice = _data["itemPrice"];
            this.deliveryPrice = _data["deliveryPrice"];
            this.totalPrice = _data["totalPrice"];
            this.serves = _data["serves"];
            this.itemPricePerServe = _data["itemPricePerServe"];
            this.totalPricePerServe = _data["totalPricePerServe"];
            this.hasDiscount = _data["hasDiscount"];
            this.discountSource = _data["discountSource"];
            this.promoCodeApplied = _data["promoCodeApplied"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SaleDisplayPriceDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemPrice"] = this.itemPrice;
        data["deliveryPrice"] = this.deliveryPrice;
        data["totalPrice"] = this.totalPrice;
        data["serves"] = this.serves;
        data["itemPricePerServe"] = this.itemPricePerServe;
        data["totalPricePerServe"] = this.totalPricePerServe;
        data["hasDiscount"] = this.hasDiscount;
        data["discountSource"] = this.discountSource;
        data["promoCodeApplied"] = this.promoCodeApplied;
        return data;
    }
}
export class IngredientGroup {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [];
                for (let item of _data["ingredients"])
                    this.ingredients.push(Ingredient.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientGroup();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        return data;
    }
}
export class Ingredient {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ingredientType = _data["ingredientType"];
            this.description = _data["description"];
            this.allergensContains = _data["allergensContains"];
            this.allergensMayContain = _data["allergensMayContain"];
            this.isCustom = _data["isCustom"];
            this.customisationSurcharge = _data["customisationSurcharge"];
            this.customisationType = _data["customisationType"];
            this.customName = _data["customName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Ingredient();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ingredientType"] = this.ingredientType;
        data["description"] = this.description;
        data["allergensContains"] = this.allergensContains;
        data["allergensMayContain"] = this.allergensMayContain;
        data["isCustom"] = this.isCustom;
        data["customisationSurcharge"] = this.customisationSurcharge;
        data["customisationType"] = this.customisationType;
        data["customName"] = this.customName;
        return data;
    }
}
export class IngredientGroupResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["ingredients"])) {
                this.ingredients = [];
                for (let item of _data["ingredients"])
                    this.ingredients.push(IngredientResponse2.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientGroupResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.ingredients)) {
            data["ingredients"] = [];
            for (let item of this.ingredients)
                data["ingredients"].push(item.toJSON());
        }
        return data;
    }
}
export class IngredientResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.ingredientType = _data["ingredientType"];
            this.description = _data["description"];
            this.allergensContains = _data["allergensContains"];
            this.allergensMayContain = _data["allergensMayContain"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new IngredientResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["ingredientType"] = this.ingredientType;
        data["description"] = this.description;
        data["allergensContains"] = this.allergensContains;
        data["allergensMayContain"] = this.allergensMayContain;
        return data;
    }
}
export var IngredientResponseIngredientType;
(function (IngredientResponseIngredientType) {
    IngredientResponseIngredientType[IngredientResponseIngredientType["_0"] = 0] = "_0";
    IngredientResponseIngredientType[IngredientResponseIngredientType["_1"] = 1] = "_1";
    IngredientResponseIngredientType[IngredientResponseIngredientType["_2"] = 2] = "_2";
})(IngredientResponseIngredientType || (IngredientResponseIngredientType = {}));
export class StepResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.number = _data["number"];
            this.heading = _data["heading"];
            this.method = _data["method"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new StepResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["heading"] = this.heading;
        data["method"] = this.method;
        return data;
    }
}
export class NutritionResponse2 {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.code = _data["code"];
            this.label = _data["label"];
            this.value = _data["value"];
            this.unit = _data["unit"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new NutritionResponse2();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["label"] = this.label;
        data["value"] = this.value;
        data["unit"] = this.unit;
        return data;
    }
}
export class RecipeCollectionResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.day = _data["day"];
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [];
                for (let item of _data["recipes"])
                    this.recipes.push(RecipeCollectionModelResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCollectionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["day"] = this.day;
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item.toJSON());
        }
        return data;
    }
}
export class RecipeCollectionModelResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.src = _data["src"];
            this.rnumber = _data["rnumber"];
            this.rversion = _data["rversion"];
            this.partition = _data["partition"];
            this.rid = _data["rid"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeCollectionModelResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["src"] = this.src;
        data["rnumber"] = this.rnumber;
        data["rversion"] = this.rversion;
        data["partition"] = this.partition;
        data["rid"] = this.rid;
        return data;
    }
}
export class AvailableExtrasResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["extraProductGroups"])) {
                this.extraProductGroups = [];
                for (let item of _data["extraProductGroups"])
                    this.extraProductGroups.push(ProductGroupWithSkusResponse.fromJS(item));
            }
            if (Array.isArray(_data["extras"])) {
                this.extras = [];
                for (let item of _data["extras"])
                    this.extras.push(ProductSummaryResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AvailableExtrasResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.extraProductGroups)) {
            data["extraProductGroups"] = [];
            for (let item of this.extraProductGroups)
                data["extraProductGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item.toJSON());
        }
        return data;
    }
}
export class ProductGroupWithSkusResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.skus = [];
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.blurb = _data["blurb"];
            this.tag = _data["tag"];
            this.iconUrl = _data["iconUrl"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["skus"])) {
                this.skus = [];
                for (let item of _data["skus"])
                    this.skus.push(SortableSkuResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupWithSkusResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["blurb"] = this.blurb;
        data["tag"] = this.tag;
        data["iconUrl"] = this.iconUrl;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.skus)) {
            data["skus"] = [];
            for (let item of this.skus)
                data["skus"].push(item.toJSON());
        }
        return data;
    }
}
export class SortableSkuResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sortOrder = _data["sortOrder"];
            this.sku = _data["sku"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SortableSkuResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder;
        data["sku"] = this.sku;
        return data;
    }
}
export class ProductSummaryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.simpleName = _data["simpleName"];
            this.sku = _data["sku"];
            this.imageUrl = _data["imageUrl"];
            this.nights = _data["nights"];
            this.people = _data["people"];
            this.totalPrice = _data["totalPrice"];
            this.deliveryPrice = _data["deliveryPrice"];
            this.pricePerPlate = _data["pricePerPlate"];
            this.isDemandLocked = _data["isDemandLocked"];
            this.pricing = _data["pricing"] ? ProductPricingResponse.fromJS(_data["pricing"]) : undefined;
            this.isVisible = _data["isVisible"];
            if (Array.isArray(_data["flexedSkus"])) {
                this.flexedSkus = [];
                for (let item of _data["flexedSkus"])
                    this.flexedSkus.push(item);
            }
            if (Array.isArray(_data["flexedSkusPricing"])) {
                this.flexedSkusPricing = [];
                for (let item of _data["flexedSkusPricing"])
                    this.flexedSkusPricing.push(FlexedSkusPricingResponse.fromJS(item));
            }
            if (Array.isArray(_data["availableFrequencies"])) {
                this.availableFrequencies = [];
                for (let item of _data["availableFrequencies"])
                    this.availableFrequencies.push(item);
            }
            this.settings = _data["settings"] ? ProductCollectionSettingsResponse.fromJS(_data["settings"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductSummaryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["simpleName"] = this.simpleName;
        data["sku"] = this.sku;
        data["imageUrl"] = this.imageUrl;
        data["nights"] = this.nights;
        data["people"] = this.people;
        data["totalPrice"] = this.totalPrice;
        data["deliveryPrice"] = this.deliveryPrice;
        data["pricePerPlate"] = this.pricePerPlate;
        data["isDemandLocked"] = this.isDemandLocked;
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["isVisible"] = this.isVisible;
        if (Array.isArray(this.flexedSkus)) {
            data["flexedSkus"] = [];
            for (let item of this.flexedSkus)
                data["flexedSkus"].push(item);
        }
        if (Array.isArray(this.flexedSkusPricing)) {
            data["flexedSkusPricing"] = [];
            for (let item of this.flexedSkusPricing)
                data["flexedSkusPricing"].push(item.toJSON());
        }
        if (Array.isArray(this.availableFrequencies)) {
            data["availableFrequencies"] = [];
            for (let item of this.availableFrequencies)
                data["availableFrequencies"].push(item);
        }
        data["settings"] = this.settings ? this.settings.toJSON() : undefined;
        return data;
    }
}
export class FlexedSkusPricingResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.nights = _data["nights"];
            this.sku = _data["sku"];
            this.flexedPrice = _data["flexedPrice"];
            this.flexedPricePerPlate = _data["flexedPricePerPlate"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FlexedSkusPricingResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["nights"] = this.nights;
        data["sku"] = this.sku;
        data["flexedPrice"] = this.flexedPrice;
        data["flexedPricePerPlate"] = this.flexedPricePerPlate;
        return data;
    }
}
export class ProductCollectionSettingsResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.productCollectionCode = _data["productCollectionCode"];
            this.canEditFromSubscription = _data["canEditFromSubscription"];
            this.canPurchaseFromSubscription = _data["canPurchaseFromSubscription"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCollectionSettingsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["productCollectionCode"] = this.productCollectionCode;
        data["canEditFromSubscription"] = this.canEditFromSubscription;
        data["canPurchaseFromSubscription"] = this.canPurchaseFromSubscription;
        return data;
    }
}
export class ProductGroupResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.blurb = _data["blurb"];
            this.tag = _data["tag"];
            this.iconUrl = _data["iconUrl"];
            this.iconSvgUrl = _data["iconSvgUrl"];
            this.sortOrder = _data["sortOrder"];
            if (Array.isArray(_data["productOptions"])) {
                this.productOptions = [];
                for (let item of _data["productOptions"])
                    this.productOptions.push(ProductSummaryResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductGroupResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["blurb"] = this.blurb;
        data["tag"] = this.tag;
        data["iconUrl"] = this.iconUrl;
        data["iconSvgUrl"] = this.iconSvgUrl;
        data["sortOrder"] = this.sortOrder;
        if (Array.isArray(this.productOptions)) {
            data["productOptions"] = [];
            for (let item of this.productOptions)
                data["productOptions"].push(item.toJSON());
        }
        return data;
    }
}
export class FiltersResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["recipes"])) {
                this.recipes = [];
                for (let item of _data["recipes"])
                    this.recipes.push(FiltersRecipeResponse.fromJS(item));
            }
            if (Array.isArray(_data["products"])) {
                this.products = [];
                for (let item of _data["products"])
                    this.products.push(FiltersProductResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.recipes)) {
            data["recipes"] = [];
            for (let item of this.recipes)
                data["recipes"].push(item.toJSON());
        }
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        return data;
    }
}
export class FiltersRecipeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.filterCode = _data["filterCode"];
            this.filterDisplay = _data["filterDisplay"];
            this.sortOrder = _data["sortOrder"];
            this.resultCount = _data["resultCount"];
            this.banner = _data["banner"] ? RecipeFiltersBannerResponse.fromJS(_data["banner"]) : undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(RecipeItemResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersRecipeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["filterCode"] = this.filterCode;
        data["filterDisplay"] = this.filterDisplay;
        data["sortOrder"] = this.sortOrder;
        data["resultCount"] = this.resultCount;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
export class RecipeFiltersBannerResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.heading = _data["heading"];
            this.extendedDescription = _data["extendedDescription"];
            this.shortDescription = _data["shortDescription"];
            this.imageUrl = _data["imageUrl"];
            this.backgroundColour = _data["backgroundColour"];
            this.textColour = _data["textColour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeFiltersBannerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["extendedDescription"] = this.extendedDescription;
        data["shortDescription"] = this.shortDescription;
        data["imageUrl"] = this.imageUrl;
        data["backgroundColour"] = this.backgroundColour;
        data["textColour"] = this.textColour;
        return data;
    }
}
export class RecipeItemResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemNumber = _data["itemNumber"];
            this.sortOrder = _data["sortOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new RecipeItemResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemNumber"] = this.itemNumber;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}
export class FiltersProductResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.filterCode = _data["filterCode"];
            this.filterDisplay = _data["filterDisplay"];
            this.sortOrder = _data["sortOrder"];
            this.resultCount = _data["resultCount"];
            this.banner = _data["banner"] ? ProductFiltersBannerResponse.fromJS(_data["banner"]) : undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(FiltersItemResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["filterCode"] = this.filterCode;
        data["filterDisplay"] = this.filterDisplay;
        data["sortOrder"] = this.sortOrder;
        data["resultCount"] = this.resultCount;
        data["banner"] = this.banner ? this.banner.toJSON() : undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
export class ProductFiltersBannerResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.heading = _data["heading"];
            this.extendedDescription = _data["extendedDescription"];
            this.shortDescription = _data["shortDescription"];
            this.imageUrl = _data["imageUrl"];
            this.backgroundColour = _data["backgroundColour"];
            this.textColour = _data["textColour"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductFiltersBannerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["heading"] = this.heading;
        data["extendedDescription"] = this.extendedDescription;
        data["shortDescription"] = this.shortDescription;
        data["imageUrl"] = this.imageUrl;
        data["backgroundColour"] = this.backgroundColour;
        data["textColour"] = this.textColour;
        return data;
    }
}
export class FiltersItemResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.itemNumber = _data["itemNumber"];
            this.sortOrder = _data["sortOrder"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new FiltersItemResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["itemNumber"] = this.itemNumber;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}
export class OrderResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliveryId = _data["deliveryId"];
            this.orderKey = _data["orderKey"];
            this.deliveryDate = _data["deliveryDate"] ? DeliveryDateResponse.fromJS(_data["deliveryDate"]) : undefined;
            this.deliveryDateSource = _data["deliveryDateSource"];
            this.originalDeliveryDate = _data["originalDeliveryDate"] ? DeliveryDateResponse.fromJS(_data["originalDeliveryDate"]) : undefined;
            this.overrideDeliveryDate = _data["overrideDeliveryDate"] ? DeliveryDateResponse.fromJS(_data["overrideDeliveryDate"]) : undefined;
            this.deliveryAddress = _data["deliveryAddress"] ? AddressResponse.fromJS(_data["deliveryAddress"]) : undefined;
            this.isCreating = _data["isCreating"];
            this.isSkipped = _data["isSkipped"];
            this.skipReason = _data["skipReason"];
            this.deliveryStatus = _data["deliveryStatus"];
            this.subscriptionId = _data["subscriptionId"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.totalCost = _data["totalCost"];
            if (Array.isArray(_data["deliveryLines"])) {
                this.deliveryLines = [];
                for (let item of _data["deliveryLines"])
                    this.deliveryLines.push(DeliveryLineResponse.fromJS(item));
            }
            this.isDeliveryAddressSameAsDefault = _data["isDeliveryAddressSameAsDefault"];
            this.isVirtual = _data["isVirtual"];
            this.isOneOffOrder = _data["isOneOffOrder"];
            this.isPriceBookApplied = _data["isPriceBookApplied"];
            this.orderActions = _data["orderActions"] ? OrderActionsResponse.fromJS(_data["orderActions"]) : undefined;
            this.isDemandLocked = _data["isDemandLocked"];
            this.hasAvailableBufferDates = _data["hasAvailableBufferDates"];
            if (Array.isArray(_data["availableRecipes"])) {
                this.availableRecipes = [];
                for (let item of _data["availableRecipes"])
                    this.availableRecipes.push(RecipeResponse.fromJS(item));
            }
            this.pricing = _data["pricing"] ? PricingResponse.fromJS(_data["pricing"]) : undefined;
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [];
                for (let item of _data["notifications"])
                    this.notifications.push(NotificationResponse.fromJS(item));
            }
            this.isFirstDeliveryForSubscription = _data["isFirstDeliveryForSubscription"];
            this.isLastDeliveryForSubscription = _data["isLastDeliveryForSubscription"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OrderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["orderKey"] = this.orderKey;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toJSON() : undefined;
        data["deliveryDateSource"] = this.deliveryDateSource;
        data["originalDeliveryDate"] = this.originalDeliveryDate ? this.originalDeliveryDate.toJSON() : undefined;
        data["overrideDeliveryDate"] = this.overrideDeliveryDate ? this.overrideDeliveryDate.toJSON() : undefined;
        data["deliveryAddress"] = this.deliveryAddress ? this.deliveryAddress.toJSON() : undefined;
        data["isCreating"] = this.isCreating;
        data["isSkipped"] = this.isSkipped;
        data["skipReason"] = this.skipReason;
        data["deliveryStatus"] = this.deliveryStatus;
        data["subscriptionId"] = this.subscriptionId;
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["totalCost"] = this.totalCost;
        if (Array.isArray(this.deliveryLines)) {
            data["deliveryLines"] = [];
            for (let item of this.deliveryLines)
                data["deliveryLines"].push(item.toJSON());
        }
        data["isDeliveryAddressSameAsDefault"] = this.isDeliveryAddressSameAsDefault;
        data["isVirtual"] = this.isVirtual;
        data["isOneOffOrder"] = this.isOneOffOrder;
        data["isPriceBookApplied"] = this.isPriceBookApplied;
        data["orderActions"] = this.orderActions ? this.orderActions.toJSON() : undefined;
        data["isDemandLocked"] = this.isDemandLocked;
        data["hasAvailableBufferDates"] = this.hasAvailableBufferDates;
        if (Array.isArray(this.availableRecipes)) {
            data["availableRecipes"] = [];
            for (let item of this.availableRecipes)
                data["availableRecipes"].push(item.toJSON());
        }
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        data["isFirstDeliveryForSubscription"] = this.isFirstDeliveryForSubscription;
        data["isLastDeliveryForSubscription"] = this.isLastDeliveryForSubscription;
        return data;
    }
}
export class SingleForecastResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.orderResponse = _data["orderResponse"] ? OrderResponse.fromJS(_data["orderResponse"]) : undefined;
            this.promo = _data["promo"] ? BenefitDto.fromJS(_data["promo"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SingleForecastResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["orderResponse"] = this.orderResponse ? this.orderResponse.toJSON() : undefined;
        data["promo"] = this.promo ? this.promo.toJSON() : undefined;
        return data;
    }
}
export class ValidatePromoResultResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.promoCode = _data["promoCode"];
            this.message = _data["message"];
            this.redeemableFrom = _data["redeemableFrom"] ? new Date(_data["redeemableFrom"].toString()) : undefined;
            this.redeemableTo = _data["redeemableTo"] ? new Date(_data["redeemableTo"].toString()) : undefined;
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(item);
            }
            this.isValid = _data["isValid"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ValidatePromoResultResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["promoCode"] = this.promoCode;
        data["message"] = this.message;
        data["redeemableFrom"] = this.redeemableFrom ? this.redeemableFrom.toISOString() : undefined;
        data["redeemableTo"] = this.redeemableTo ? this.redeemableTo.toISOString() : undefined;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        data["isValid"] = this.isValid;
        return data;
    }
}
export class PromoOverride {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.benefit = _data["benefit"] ? BenefitDto.fromJS(_data["benefit"]) : undefined;
            this.promoValidationError = _data["promoValidationError"];
            this.promoIdApplied = _data["promoIdApplied"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PromoOverride();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["benefit"] = this.benefit ? this.benefit.toJSON() : undefined;
        data["promoValidationError"] = this.promoValidationError;
        data["promoIdApplied"] = this.promoIdApplied;
        return data;
    }
}
export class CodeValidationResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.discount = _data["discount"] ? PromoDto.fromJS(_data["discount"]) : undefined;
            if (Array.isArray(_data["validationErrors"])) {
                this.validationErrors = [];
                for (let item of _data["validationErrors"])
                    this.validationErrors.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CodeValidationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount ? this.discount.toJSON() : undefined;
        if (Array.isArray(this.validationErrors)) {
            data["validationErrors"] = [];
            for (let item of this.validationErrors)
                data["validationErrors"].push(item);
        }
        return data;
    }
}
export class PromoDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            this.discountType = _data["discountType"];
            if (Array.isArray(_data["benefits"])) {
                this.benefits = [];
                for (let item of _data["benefits"])
                    this.benefits.push(BenefitDto.fromJS(item));
            }
            this.promoGroupId = _data["promoGroupId"];
            this.forNewOrReturningCustomers = _data["forNewOrReturningCustomers"];
            if (Array.isArray(_data["validForProducts"])) {
                this.validForProducts = [];
                for (let item of _data["validForProducts"])
                    this.validForProducts.push(ProductSummary.fromJS(item));
            }
            this.redeemableFrom = _data["redeemableFrom"] ? new Date(_data["redeemableFrom"].toString()) : undefined;
            this.redeemableTo = _data["redeemableTo"] ? new Date(_data["redeemableTo"].toString()) : undefined;
            this.bannerUrlSmall = _data["bannerUrlSmall"];
            this.bannerUrlMedium = _data["bannerUrlMedium"];
            this.bannerUrlLarge = _data["bannerUrlLarge"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PromoDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        data["discountType"] = this.discountType;
        if (Array.isArray(this.benefits)) {
            data["benefits"] = [];
            for (let item of this.benefits)
                data["benefits"].push(item.toJSON());
        }
        data["promoGroupId"] = this.promoGroupId;
        data["forNewOrReturningCustomers"] = this.forNewOrReturningCustomers;
        if (Array.isArray(this.validForProducts)) {
            data["validForProducts"] = [];
            for (let item of this.validForProducts)
                data["validForProducts"].push(item.toJSON());
        }
        data["redeemableFrom"] = this.redeemableFrom ? this.redeemableFrom.toISOString() : undefined;
        data["redeemableTo"] = this.redeemableTo ? this.redeemableTo.toISOString() : undefined;
        data["bannerUrlSmall"] = this.bannerUrlSmall;
        data["bannerUrlMedium"] = this.bannerUrlMedium;
        data["bannerUrlLarge"] = this.bannerUrlLarge;
        return data;
    }
}
export var DiscountType;
(function (DiscountType) {
    DiscountType[DiscountType["Promo"] = 0] = "Promo";
    DiscountType[DiscountType["RaF"] = 1] = "RaF";
    DiscountType[DiscountType["PromoGroup"] = 2] = "PromoGroup";
})(DiscountType || (DiscountType = {}));
export class CalendarResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [];
                for (let item of _data["orders"])
                    this.orders.push(CalendarOrderResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            for (let item of this.orders)
                data["orders"].push(item.toJSON());
        }
        return data;
    }
}
export class CalendarOrderResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.week = _data["week"] ? new Date(_data["week"].toString()) : undefined;
            this.deliveryDateId = _data["deliveryDateId"];
            this.isSkipped = _data["isSkipped"];
            this.sku = _data["sku"];
            this.actions = _data["actions"] ? OrderActionsResponse.fromJS(_data["actions"]) : undefined;
            this.isDemandLocked = _data["isDemandLocked"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarOrderResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["week"] = this.week ? this.week.toISOString() : undefined;
        data["deliveryDateId"] = this.deliveryDateId;
        data["isSkipped"] = this.isSkipped;
        data["sku"] = this.sku;
        data["actions"] = this.actions ? this.actions.toJSON() : undefined;
        data["isDemandLocked"] = this.isDemandLocked;
        return data;
    }
}
export class UpdateDeliveryShippingResponseDto {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.errorMessage = _data["errorMessage"];
            this.newAddress = _data["newAddress"];
            this.success = _data["success"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeliveryShippingResponseDto();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["errorMessage"] = this.errorMessage;
        data["newAddress"] = this.newAddress;
        data["success"] = this.success;
        return data;
    }
}
export class UpdateDeliveryShippingRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.addressId = _data["addressId"];
            this.deliveryDateId = _data["deliveryDateId"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.deliveryWeek = _data["deliveryWeek"] ? new Date(_data["deliveryWeek"].toString()) : undefined;
            this.deliveryId = _data["deliveryId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateDeliveryShippingRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["addressId"] = this.addressId;
        data["deliveryDateId"] = this.deliveryDateId;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["deliveryWeek"] = this.deliveryWeek ? this.deliveryWeek.toISOString() : undefined;
        data["deliveryId"] = this.deliveryId;
        return data;
    }
}
export class DeliveryDatesResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["deliveryDates"])) {
                this.deliveryDates = [];
                for (let item of _data["deliveryDates"])
                    this.deliveryDates.push(DeliveryDateResponse.fromJS(item));
            }
            this.errorMessage = _data["errorMessage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new DeliveryDatesResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deliveryDates)) {
            data["deliveryDates"] = [];
            for (let item of this.deliveryDates)
                data["deliveryDates"].push(item.toJSON());
        }
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}
export class GetSalesShippingDeliveryDatesRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliveryId = _data["deliveryId"];
            this.addressId = _data["addressId"];
            this.sku = _data["sku"];
            this.weekStarting = _data["weekStarting"] ? new Date(_data["weekStarting"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new GetSalesShippingDeliveryDatesRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryId"] = this.deliveryId;
        data["addressId"] = this.addressId;
        data["sku"] = this.sku;
        data["weekStarting"] = this.weekStarting ? this.weekStarting.toISOString() : undefined;
        return data;
    }
}
export class AccountCreateSubscriptionRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.deliveryDateId = _data["deliveryDateId"];
            this.sku = _data["sku"];
            this.promoCode = _data["promoCode"];
            this.frequency = _data["frequency"];
            this.overrideDeliverySlotId = _data["overrideDeliverySlotId"];
            this.addressId = _data["addressId"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            if (Array.isArray(_data["extras"])) {
                this.extras = [];
                for (let item of _data["extras"])
                    this.extras.push(ExtrasItemRequestBody.fromJS(item));
            }
            if (Array.isArray(_data["selections"])) {
                this.selections = [];
                for (let item of _data["selections"])
                    this.selections.push(ChoiceSelectionsRequestBody.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCreateSubscriptionRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryDateId"] = this.deliveryDateId;
        data["sku"] = this.sku;
        data["promoCode"] = this.promoCode;
        data["frequency"] = this.frequency;
        data["overrideDeliverySlotId"] = this.overrideDeliverySlotId;
        data["addressId"] = this.addressId;
        data["deliveryInstructions"] = this.deliveryInstructions;
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item.toJSON());
        }
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item.toJSON());
        }
        return data;
    }
}
export class ExtrasItemRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.frequency = _data["frequency"];
            if (Array.isArray(_data["addOnToRecipeNumbers"])) {
                this.addOnToRecipeNumbers = [];
                for (let item of _data["addOnToRecipeNumbers"])
                    this.addOnToRecipeNumbers.push(item);
            }
            this.deliveryWeek = _data["deliveryWeek"] ? new Date(_data["deliveryWeek"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ExtrasItemRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["frequency"] = this.frequency;
        if (Array.isArray(this.addOnToRecipeNumbers)) {
            data["addOnToRecipeNumbers"] = [];
            for (let item of this.addOnToRecipeNumbers)
                data["addOnToRecipeNumbers"].push(item);
        }
        data["deliveryWeek"] = this.deliveryWeek ? this.deliveryWeek.toISOString() : undefined;
        return data;
    }
}
export class ChoiceSelectionsRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.categoryCode = _data["categoryCode"];
            this.quantity = _data["quantity"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ChoiceSelectionsRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["categoryCode"] = this.categoryCode;
        data["quantity"] = this.quantity;
        return data;
    }
}
export class AccountUpdateSubscriptionResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionNumber = _data["subscriptionNumber"];
            this.current = _data["current"] ? AccountSubscriptionChangeSummaryResponse.fromJS(_data["current"]) : undefined;
            this.previous = _data["previous"] ? AccountSubscriptionChangeSummaryResponse.fromJS(_data["previous"]) : undefined;
            this.feedbackMessage = _data["feedbackMessage"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUpdateSubscriptionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["subscriptionNumber"] = this.subscriptionNumber;
        data["current"] = this.current ? this.current.toJSON() : undefined;
        data["previous"] = this.previous ? this.previous.toJSON() : undefined;
        data["feedbackMessage"] = this.feedbackMessage;
        return data;
    }
}
export class AccountSubscriptionChangeSummaryResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.frequency = _data["frequency"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSubscriptionChangeSummaryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["frequency"] = this.frequency;
        return data;
    }
}
export class AccountUpdateSubscriptionRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.promoCode = _data["promoCode"];
            this.addressId = _data["addressId"];
            this.deliveryInstructions = _data["deliveryInstructions"];
            this.deliverySlotId = _data["deliverySlotId"];
            this.frequency = _data["frequency"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUpdateSubscriptionRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["promoCode"] = this.promoCode;
        data["addressId"] = this.addressId;
        data["deliveryInstructions"] = this.deliveryInstructions;
        data["deliverySlotId"] = this.deliverySlotId;
        data["frequency"] = this.frequency;
        return data;
    }
}
export class AccountUpdatePlanYourWeekResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUpdatePlanYourWeekResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}
export class AccountUpdatePlanYourWeekRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [];
                for (let item of _data["selections"])
                    this.selections.push(ChoiceSelectionsRequestBody.fromJS(item));
            }
            if (Array.isArray(_data["extras"])) {
                this.extras = [];
                for (let item of _data["extras"])
                    this.extras.push(ExtrasItemRequestBody.fromJS(item));
            }
            this.promoCode = _data["promoCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUpdatePlanYourWeekRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item.toJSON());
        }
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item.toJSON());
        }
        data["promoCode"] = this.promoCode;
        return data;
    }
}
export class CostPreviewResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.pricing = new PricingResponse();
            this.primaryProduct = new ProductLineItemResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.pricing = _data["pricing"] ? PricingResponse.fromJS(_data["pricing"]) : new PricingResponse();
            this.primaryProduct = _data["primaryProduct"] ? ProductLineItemResponse.fromJS(_data["primaryProduct"]) : new ProductLineItemResponse();
            this.shipping = _data["shipping"] ? ProductLineItemResponse.fromJS(_data["shipping"]) : undefined;
            if (Array.isArray(_data["extras"])) {
                this.extras = [];
                for (let item of _data["extras"])
                    this.extras.push(ProductLineItemResponse.fromJS(item));
            }
            if (Array.isArray(_data["notifications"])) {
                this.notifications = [];
                for (let item of _data["notifications"])
                    this.notifications.push(NotificationResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CostPreviewResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["pricing"] = this.pricing ? this.pricing.toJSON() : undefined;
        data["primaryProduct"] = this.primaryProduct ? this.primaryProduct.toJSON() : undefined;
        data["shipping"] = this.shipping ? this.shipping.toJSON() : undefined;
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item.toJSON());
        }
        if (Array.isArray(this.notifications)) {
            data["notifications"] = [];
            for (let item of this.notifications)
                data["notifications"].push(item.toJSON());
        }
        return data;
    }
}
export class ProductLineItemResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.price = _data["price"];
            this.subTotal = _data["subTotal"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductLineItemResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["price"] = this.price;
        data["subTotal"] = this.subTotal;
        return data;
    }
}
export class CostPreviewRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.baseSku = _data["baseSku"];
            this.promoCode = _data["promoCode"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            if (Array.isArray(_data["selections"])) {
                this.selections = [];
                for (let item of _data["selections"])
                    this.selections.push(ChoiceSelectionsRequestBody.fromJS(item));
            }
            if (Array.isArray(_data["extras"])) {
                this.extras = [];
                for (let item of _data["extras"])
                    this.extras.push(ExtrasItemRequestBody.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CostPreviewRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["baseSku"] = this.baseSku;
        data["promoCode"] = this.promoCode;
        data["subscriptionNumber"] = this.subscriptionNumber;
        if (Array.isArray(this.selections)) {
            data["selections"] = [];
            for (let item of this.selections)
                data["selections"].push(item.toJSON());
        }
        if (Array.isArray(this.extras)) {
            data["extras"] = [];
            for (let item of this.extras)
                data["extras"].push(item.toJSON());
        }
        return data;
    }
}
export class AccountValidateProductChangeResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["incompatibleExtras"])) {
                this.incompatibleExtras = [];
                for (let item of _data["incompatibleExtras"])
                    this.incompatibleExtras.push(AccountSubscriptionExtraResponse.fromJS(item));
            }
            if (Array.isArray(_data["remainingExtras"])) {
                this.remainingExtras = [];
                for (let item of _data["remainingExtras"])
                    this.remainingExtras.push(AccountSubscriptionExtraResponse.fromJS(item));
            }
            this.incompatibleSubscriptionOverrides = _data["incompatibleSubscriptionOverrides"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountValidateProductChangeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.incompatibleExtras)) {
            data["incompatibleExtras"] = [];
            for (let item of this.incompatibleExtras)
                data["incompatibleExtras"].push(item.toJSON());
        }
        if (Array.isArray(this.remainingExtras)) {
            data["remainingExtras"] = [];
            for (let item of this.remainingExtras)
                data["remainingExtras"].push(item.toJSON());
        }
        data["incompatibleSubscriptionOverrides"] = this.incompatibleSubscriptionOverrides;
        return data;
    }
}
export class AccountSubscriptionExtraResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.productName = _data["productName"];
            this.price = _data["price"];
            this.imageUrl = _data["imageUrl"];
            this.frequency = _data["frequency"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSubscriptionExtraResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["productName"] = this.productName;
        data["price"] = this.price;
        data["imageUrl"] = this.imageUrl;
        data["frequency"] = this.frequency;
        return data;
    }
}
export class AccountValidateProductChangeRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.newSku = _data["newSku"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountValidateProductChangeRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["newSku"] = this.newSku;
        return data;
    }
}
export class Result {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}
export class SkipDeliveryRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.week = new Week();
        }
    }
    init(_data) {
        if (_data) {
            this.week = _data["week"] ? Week.fromJS(_data["week"]) : new Week();
            this.triggerId = _data["triggerId"];
            this.isSkippedFromCalendar = _data["isSkippedFromCalendar"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SkipDeliveryRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["week"] = this.week ? this.week.toJSON() : undefined;
        data["triggerId"] = this.triggerId;
        data["isSkippedFromCalendar"] = this.isSkippedFromCalendar;
        return data;
    }
}
export class Week {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new Week();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class UnSkipDeliveryRequest {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.week = new Week();
        }
    }
    init(_data) {
        if (_data) {
            this.week = _data["week"] ? Week.fromJS(_data["week"]) : new Week();
            this.isSkippedFromCalendar = _data["isSkippedFromCalendar"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new UnSkipDeliveryRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["week"] = this.week ? this.week.toJSON() : undefined;
        data["isSkippedFromCalendar"] = this.isSkippedFromCalendar;
        return data;
    }
}
export class CancelSubscriptionResponse {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CancelSubscriptionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}
export class AccountCancelSubscriptionRequestBody {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.customerMessageTriggerId = _data["customerMessageTriggerId"];
            this.lastDeliveryDateId = _data["lastDeliveryDateId"];
            this.cancellationComments = _data["cancellationComments"];
            this.cancellationReason = _data["cancellationReason"];
            this.wouldConsiderReturning = _data["wouldConsiderReturning"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new AccountCancelSubscriptionRequestBody();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["customerMessageTriggerId"] = this.customerMessageTriggerId;
        data["lastDeliveryDateId"] = this.lastDeliveryDateId;
        data["cancellationComments"] = this.cancellationComments;
        data["cancellationReason"] = this.cancellationReason;
        data["wouldConsiderReturning"] = this.wouldConsiderReturning;
        return data;
    }
}
export class SubscriptionTrackingMetadata {
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.customerNumber = _data["customerNumber"];
            this.subscriptionNumber = _data["subscriptionNumber"];
            if (_data["metadata"]) {
                this.metadata = {};
                for (let key in _data["metadata"]) {
                    if (_data["metadata"].hasOwnProperty(key))
                        this.metadata[key] = _data["metadata"][key];
                }
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SubscriptionTrackingMetadata();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["customerNumber"] = this.customerNumber;
        data["subscriptionNumber"] = this.subscriptionNumber;
        if (this.metadata) {
            data["metadata"] = {};
            for (let key in this.metadata) {
                if (this.metadata.hasOwnProperty(key))
                    data["metadata"][key] = this.metadata[key];
            }
        }
        return data;
    }
}
export class ApiAccountException extends Error {
    constructor(message, status, response, headers, result) {
        super();
        this.isApiAccountException = true;
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    static isApiAccountException(obj) {
        return obj.isApiAccountException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiAccountException(message, status, response, headers, null);
}
export class ApimClientConfiguration {
    constructor() {
        this._apiHeader = "Ocp-Apim-Subscription-Key";
    }
    setApiKey(key) {
        this._apiKey = key;
    }
    applyTransformToRequest(options) {
        options.headers[this._apiHeader] = this._apiKey;
    }
}
export class FunctionAppClientConfiguration {
    constructor() {
        this._apiHeader = "x-functions-key";
    }
    setApiKey(key) {
        this._apiKey = key;
    }
    applyTransformToRequest(options) {
        options.headers[this._apiHeader] = this._apiKey;
    }
}
